import React, { useState, useEffect, useRef, useMemo } from 'react';
import dayjs from 'dayjs';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import {
  cleanCustomerId,
  telemetrylatestdata,
  customerbaseddevices,
  customerbasedshift
} from '../../Services/app/companyservice';
import { CustomDaySelect, CustomDateSelect } from '../Inputfield/inputfield';
import { telemetrykeydata } from '../../Services/app/andondashboardservice';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { DesktopTimePicker } from '@mui/x-date-pickers/DesktopTimePicker';
import Swal from 'sweetalert2';
import { Downtimeadd1, DowntimeaddDelete, Deviceattributeget, Downtimeadd2, DowntimeaddDelete1 } from '../../Services/app/masterservice';
import { updateIdleReason } from '../../Services/app/reportservice';
import { Autocomplete, FormControl, FormHelperText, Tabs, Tab } from '@mui/material';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import SmartOperator from '../SmartOperator/SmartOperator';

const OperatorDetails = () => {
  const params = new URLSearchParams(window.location.search);
  const token = localStorage.getItem('token');
  const customerId = localStorage.getItem('CustomerID');
  const customerId1 = cleanCustomerId(customerId);
  // Page-level tab: 'allocation' = existing view; 'assignment' = embedded SmartOperator
  const [activeTab, setActiveTab] = useState(() => {
    const t = (new URLSearchParams(window.location.search)).get('tab');
    return t === 'assignment' ? 'assignment' : 'allocation';
  });
  const [selectedDevicename, setSelectedDevicename] = useState(null);
  const [selectedDeviceId, setSelectedDeviceId] = useState(null);
  const [mismatchOpen, setMismatchOpen] = useState(false);
  const [mismatchLoading, setMismatchLoading] = useState(false);
  const [mismatchEvents, setMismatchEvents] = useState([]);
  const [liveMismatches, setLiveMismatches] = useState([]);
  const [autoSuggestStatus, setAutoSuggestStatus] = useState(null);
  const [autoSuggestLoading, setAutoSuggestLoading] = useState(false);
  const [mismatchSort, setMismatchSort] = useState({ col: 'machining_variance_pct', dir: 'desc' });
  const [mismatchShiftStartIst, setMismatchShiftStartIst] = useState(null);
  const [mismatchSkipped, setMismatchSkipped] = useState([]);
  // Bulk auto-assign preview state — list of rows the supervisor reviews before applying
  const [bulkPreviewOpen, setBulkPreviewOpen] = useState(false);
  const [bulkPreviewLoading, setBulkPreviewLoading] = useState(false);
  const [bulkPreviewRows, setBulkPreviewRows] = useState([]);
  const [bulkSelected, setBulkSelected] = useState(new Set());
  const [bulkApplying, setBulkApplying] = useState(false);
  const [startDateTime, setStartDateTime] = useState(null);
  const [endDateTime, setEndDateTime] = useState(null);
  const [iframeKey, setIframeKey] = useState(0);
  const [iframeUrl, setIframeUrl] = useState('');
  const initialLoad = useRef(true);
  const [selectedDevice, setSelectedDevice] = useState('');
  const [utilizationData, setUtilizationData] = useState([]);
  const [devices, setDevices] = useState([]);
  const [formattedUtilization, setFormattedUtilization] = useState('');
  const [Deviceid, setdeviceid] = useState('');
  const [Devicename, setdevicename] = useState('');
  const [deviceOptions, setDeviceOptions] = useState([]);
  const [iframeInteractive, setIframeInteractive] = useState(true);
  const [Assignmodes, setAssignmodes] = useState([]);
  const [selectedassignmode, setSelectedassignmode] = useState('');
  const [operators, setoperators] = useState([]);
  const [operatorslist, setoperatorslist] = useState([]);
  const [operatorsByDevice, setOperatorsByDevice] = useState({});
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [loading, setLoading] = useState(false);
  const [shifts, setShifts] = useState([]);
  const [filteredResult, setfilteredResult] = useState([]); // Changed from {} to []
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedShift, setSelectedShift] = useState('');
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs());
  const [operatorselected, setselectedoperator] = useState('');
  const [epochRange, setEpochRange] = useState({ from: null, to: null });
  const [shiftOptions, setShiftOptions] = useState([]);
  const customDaySelectRef = useRef();
  const selectRef = useRef();
  const [deviceThresholds, setDeviceThresholds] = useState({});
  const [components, setcomponents] = useState([]);
  const [componentslist, setcomponentslist] = useState([]);
  const [componentselected, setselectedcomponent] = useState('');
  const [openEditDialog1, setOpenEditDialog1] = useState(false);
  const [reasons, setreasons] = useState([]);
  const [reasonslist, setreasonslist] = useState([]);
  const [reasonselected, setselectedreason] = useState('');
  const [openEditDialog2, setOpenEditDialog2] = useState(false);
  const [supervisors, setsupervisors] = useState([]);
  const [supervisorslist, setsupervisorslist] = useState([]);
  const [supervisorsByDevice, setSupervisorByDevice] = useState([]);
  const [supervisorselected, setselectedsupervisor] = useState('');
  const [OpenEditDialog4, setOpenEditDialog4] = useState(false);
  const [selectedComponentId, setSelectedComponentId] = useState('');
  const [selectedOperatorId, setSelectedOperatorId] = useState('');
  const [operatorName, setOperatorName] = useState('');
  const [savingComponent, setSavingComponent] = useState(false);
  const [selectedProcess, setSelectedProcess] = useState('');
  const [reasonGroupOptions, setReasonGroupOptions] = useState([]);
  const [timeErrors, setTimeErrors] = useState({
    startTime: '',
    endTime: ''
  });
  const [savingStates, setSavingStates] = useState({
    operator: false,
    component: false,
    supervisor: false
  });

  const [dateErrors, setDateErrors] = useState({
    operator: '',
    component: '',
    supervisor: ''
  });
  const [processGroupOptions, setProcessGroupOptions] = useState([]);
  const [isBeforeFirstShift, setIsBeforeFirstShift] = useState(false);

  useEffect(() => {
    if (!shifts.length) return;
    const firstShift = [...shifts].sort((a, b) => Number(a.shift_no) - Number(b.shift_no))[0];
    if (!firstShift) return;

    const [h, m] = firstShift.start_time.split(':').map(Number);
    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();
    const firstShiftMinutes = h * 60 + m;

    if (currentMinutes < firstShiftMinutes) {
      setIsBeforeFirstShift(true);

      const msUntilStart =
        ((firstShiftMinutes - currentMinutes) * 60 - now.getSeconds()) * 1000
        - now.getMilliseconds();

      const timer = setTimeout(() => {
        setIsBeforeFirstShift(false);
      }, msUntilStart);

      return () => clearTimeout(timer);
    } else {
      setIsBeforeFirstShift(false);
    }
  }, [shifts]);


  useEffect(() => {
    if (openEditDialog || openEditDialog1 || OpenEditDialog4) {
      const dateError = validateDate(selectedDate);
      const newDateErrors = {
        operator: openEditDialog ? dateError : '',
        component: openEditDialog1 ? dateError : '',
        supervisor: OpenEditDialog4 ? dateError : ''
      };
      setDateErrors(newDateErrors);
    }
  }, [selectedDate, openEditDialog, openEditDialog1, OpenEditDialog4]);

  useEffect(() => {
    if (openEditDialog || openEditDialog1 || OpenEditDialog4) {
      const startError = validateStartTime(startTime);
      const endError = validateEndTime(endTime);
      setTimeErrors({
        startTime: startError,
        endTime: endError
      });
    }
  }, [startTime, endTime, selectedDate, selectedShift, openEditDialog, openEditDialog1, OpenEditDialog4]);

  const validateDate = (date) => {
    if (!date || !date.isValid()) {
      return 'Invalid date format';
    }
    const minDate = isBeforeFirstShift ? dayjs().subtract(1, 'day').startOf('day') : dayjs().startOf('day');
    const maxDate = dayjs().add(7, 'day').endOf('day');
    if (date.isBefore(minDate, 'day')) {
      return 'Date cannot be in the past.';
    }
    if (date.isAfter(maxDate)) {
      return 'Date cannot be more than 7 days from today.';
    }
    return '';
  };

  const handleTimeChange = (type, value, dialogType) => {
    if (type === 'start') {
      setStartTime(value);
    } else {
      setEndTime(value);
    }
    const startError = validateStartTime(type === 'start' ? value : startTime);
    const endError = validateEndTime(type === 'end' ? value : endTime);
    setTimeErrors({
      startTime: startError,
      endTime: endError
    });
    if (dialogType === 'component' && type === 'start' && value && endTime) {
      setTimeout(() => validateAndCheckOverlap1(value, endTime), 100);
    } else if (dialogType === 'component' && type === 'end' && startTime && value) {
      setTimeout(() => validateAndCheckOverlap1(startTime, value), 100);
    }
  };

  const handleStartTimeChange = (value) => handleTimeChange('start', value, 'operator');
  const handleEndTimeChange = (value) => handleTimeChange('end', value, 'operator');
  const handleStartTimeChange1 = (value) => handleTimeChange('start', value, 'component');
  const handleEndTimeChange1 = (value) => handleTimeChange('end', value, 'component');

  const validateStartTime = (value) => {
    if (!value) return 'Start time is required';
    if (!value.isValid()) {
      return 'Invalid time format';
    }
    const selectedShiftData = shifts.find(
      (shift) => shift.shift_no === selectedShift
    );
    if (!selectedShiftData) return '';
    const now = dayjs();
    const isToday = selectedDate.isSame(now, 'day');
    const { shiftStart, shiftEnd } = getShiftBoundaries(selectedShiftData, selectedDate);
    const selectedDateTime = getAdjustedDateTime(value, selectedDate, selectedShiftData);
    if (!selectedDateTime || !shiftStart || !shiftEnd) {
      return 'Unable to validate time';
    }
    if (isToday && selectedDateTime.isBefore(now, 'minute')) {
      return "Start time can't be in the past";
    }
    if (endTime) {
      const adjustedEnd = getAdjustedDateTime(endTime, selectedDate, selectedShiftData);
      if (selectedDateTime.isSame(adjustedEnd, 'second')) {
        return 'Start and end time cannot be the same';
      }
      if (selectedDateTime.isAfter(adjustedEnd)) {
        return 'Start time cannot be after end time';
      }
    }
    const formattedStart = shiftStart.format('DD-MM-YYYY hh:mm:ss A');
    const formattedEnd = shiftEnd.format('DD-MM-YYYY hh:mm:ss A');
    if (selectedDateTime.isBefore(shiftStart) || selectedDateTime.isAfter(shiftEnd)) {
      return `Start time must be within shift ${formattedStart} - ${formattedEnd}`;
    }
    return '';
  };

  const validateEndTime = (value) => {
    if (!value) return 'End time is required';
    if (!value.isValid()) {
      return 'Invalid time format';
    }
    const selectedShiftData = shifts.find(
      (shift) => shift.shift_no === selectedShift
    );
    if (!selectedShiftData) return '';
    const now = dayjs();
    const isToday = selectedDate.isSame(now, 'day');
    const { shiftStart, shiftEnd } = getShiftBoundaries(selectedShiftData, selectedDate);
    const selectedDateTime = getAdjustedDateTime(value, selectedDate, selectedShiftData);
    if (!selectedDateTime || !shiftStart || !shiftEnd) {
      return 'Unable to validate time';
    }
    if (isToday && selectedDateTime.isBefore(now, 'second')) {
      return 'End time must be in the future';
    }
    if (startTime) {
      const adjustedStart = getAdjustedDateTime(startTime, selectedDate, selectedShiftData);
      if (selectedDateTime.isSame(adjustedStart, 'second')) {
        return 'End and start time cannot be the same';
      }
      if (selectedDateTime.isBefore(adjustedStart)) {
        return 'End time cannot be before start time';
      }
    }
    const formattedStart = shiftStart.format('DD-MM-YYYY hh:mm:ss A');
    const formattedEnd = shiftEnd.format('DD-MM-YYYY hh:mm:ss A');
    if (selectedDateTime.isBefore(shiftStart) || selectedDateTime.isAfter(shiftEnd)) {
      return `End time must be within shift ${formattedStart} - ${formattedEnd}`;
    }
    return '';
  };

  const getEpochFromShift = (shiftNo, selectedDateObj) => {
    if (!shiftNo || !selectedDateObj || shifts.length === 0) {
      return { fromEpoch: null, toEpoch: null };
    }

    const selectedShiftData = shifts.find(shift => shift.shift_no === shiftNo);
    if (!selectedShiftData) {
      return { fromEpoch: null, toEpoch: null };
    }

    const { shiftStart, shiftEnd } = getShiftBoundaries(selectedShiftData, selectedDateObj);

    return {
      fromEpoch: shiftStart.valueOf(),
      toEpoch: shiftEnd.valueOf()
    };
  };
  const getEpochFromShift1 = (shiftNo, selectedDateObj) => {
    if (!shiftNo || !selectedDateObj || shifts.length === 0) {
      return { fromEpoch: null, toEpoch: null };
    }

    const selectedShiftData = shifts.find(shift => shift.shift_no === shiftNo);
    if (!selectedShiftData) {
      return { fromEpoch: null, toEpoch: null };
    }

    const dateStr = selectedDateObj.format('YYYY-MM-DD');
    const startDateTime = dayjs(`${dateStr}T${selectedShiftData.start_time}`);

    let endDateTime;
    if (String(shiftNo) === "2" || shiftNo === 2) {
      const nextDay = selectedDateObj.add(1, 'day').format('YYYY-MM-DD');
      endDateTime = dayjs(`${nextDay}T${selectedShiftData.end_time}`);
    } else {
      endDateTime = dayjs(`${dateStr}T${selectedShiftData.end_time}`);
    }

    if (String(shiftNo) !== "2" && shiftNo !== 2) {
      const todayStr = dayjs().format('YYYY-MM-DD');
      if (dateStr === todayStr) {
        const now = dayjs();
        if (now.isBefore(endDateTime)) {
          endDateTime = now;
        }
      }
    }

    return {
      fromEpoch: startDateTime.valueOf(),
      toEpoch: endDateTime.valueOf()
    };
  };
  const isTimeInShift = (time, shift) => {
    if (!shift) return true;
    const start = dayjs(shift.start_time, 'HH:mm:ss');
    const end = dayjs(shift.end_time, 'HH:mm:ss');
    // Overnight shift
    if (end.isBefore(start)) {
      return time.isAfter(start) || time.isBefore(end) || time.isSame(start) || time.isSame(end);
    }
    // Normal shift
    return (time.isAfter(start) && time.isBefore(end)) || time.isSame(start) || time.isSame(end);
  };
  // const handleStartTimeChange = async (value) => {
  //   if (!value) return;

  //   // 1. Check if start time equals end time (to the second)
  //   if (dayjs(value).isSame(endTime, 'second')) {
  //     setOpenEditDialog(false);
  //     setOpenEditDialog4(false);
  //     setOpenEditDialog1(false);
  //     Swal.fire('Error', 'Start Time and End Time cannot be the same!', 'error');
  //     return;
  //   }

  //   // // 2. Check if start time is within shift range
  //   // if (!isTimeInShift(value, selectedShiftData)) {
  //   //   setOpenEditDialog(false);
  //   //   setOpenEditDialog1(false);
  //   //   setOpenEditDialog4(false);
  //   //   Swal.fire('Error', 'Selected time is outside the shift range!', 'error');
  //   //   return;
  //   // }

  //   // 3. Proceed
  //   setStartTime(value);

  //   // 4. Check overlap if endTime exists
  //   if (endTime) {
  //     await validateAndCheckOverlap(value, endTime);
  //   }
  // };

  // const handleStartTimeChange1 = async (value) => {
  //   setStartTime(value);
  //   const startError = validateStartTime(value);
  //   const endError = endTime ? validateEndTime(endTime) : '';
  //   setTimeErrors({
  //     startTime: startError,
  //     endTime: endError
  //   });
  //   if (value && endTime && !startError && !endError) {
  //     await validateAndCheckOverlap1(value, endTime);
  //   }
  // };

  // const handleEndTimeChange1 = async (value) => {
  //   setEndTime(value);
  //   const endError = validateEndTime(value);
  //   const startError = startTime ? validateStartTime(startTime) : '';
  //   setTimeErrors({
  //     startTime: startError,
  //     endTime: endError
  //   });
  //   if (startTime && value && !startError && !endError) {
  //     await validateAndCheckOverlap1(startTime, value);
  //   }
  // };

  const validateAndCheckOverlap = async (newStart, newEnd) => {
    if (!selectedDate || !selectedDeviceId?.id) return false;

    const fromEpoch = dayjs(selectedDate).hour(newStart.hour()).minute(newStart.minute()).second(newStart.second()).valueOf();
    const toEpoch = dayjs(selectedDate).hour(newEnd.hour()).minute(newEnd.minute()).second(newEnd.second()).valueOf();

    // Ensure start time is before end time
    if (fromEpoch >= toEpoch) {
      Swal.fire('Error', 'Start time must be before end time.', 'error');
      return false;
    }

    const hasOverlap = await checkOperatorTimeOverlap(selectedDeviceId.id, fromEpoch, toEpoch);

    if (hasOverlap) {
      Swal.fire('Error', 'Selected time overlaps with an already assigned operator.', 'error');
      return false;
    }
  };
  const validateAndCheckOverlap1 = async (newStart, newEnd) => {
    if (!selectedDate || !selectedDeviceId?.id) return false;

    const selectedShiftData = shifts.find(shift => shift.shift_no === selectedShift);
    if (!selectedShiftData) return false;
    const fromDateTime = getAdjustedDateTime(newStart, selectedDate, selectedShiftData);
    const toDateTime = getAdjustedDateTime(newEnd, selectedDate, selectedShiftData);
    if (!fromDateTime || !toDateTime) return false;
    const fromEpoch = fromDateTime.valueOf();
    const toEpoch = toDateTime.valueOf();

    // Ensure start time is before end time
    if (fromEpoch >= toEpoch) {
      Swal.fire('Error', 'Start time must be before end time.', 'error');
      setStartTime(null);
      setEndTime(null);
      return false;
    }

    const hasOverlap = await checkOperatorTimeOverlap1(selectedDeviceId.id, fromEpoch, toEpoch);

    if (hasOverlap) {
      Swal.fire('Error', 'Selected time overlaps with an already assigned component.', 'error');
      setStartTime(null);
      setEndTime(null);
    }
  };
  const checkOperatorTimeOverlap = async (deviceId, fromEpoch, toEpoch) => {
    try {
      // Get all existing operator assignments for this device, not just within the new time range


      const response = await telemetrykeydata(deviceId, 'DEVICE', 'live_operator', 0, Date.now());

      const existingData = response?.live_operator || [];

      for (const item of existingData) {
        if (!item?.value) continue;

        let parsed = {};
        try {
          parsed = JSON.parse(item.value);
        } catch (e) {
          continue;
        }

        const existingStart = parsed.start_time || item.ts;
        const existingEnd = parsed.end_time || (existingStart + (parsed.duration || 0) * 1000);

        // Check overlap: if the new time range overlaps with any existing assignment
        const isOverlapping = fromEpoch < existingEnd && existingStart < toEpoch;
        if (isOverlapping) {
          console.log('Overlap detected:', {
            newStart: new Date(fromEpoch),
            newEnd: new Date(toEpoch),
            existingStart: new Date(existingStart),
            existingEnd: new Date(existingEnd),
            operator: parsed.operator
          });
          return true; // Conflict found
        }
      }

      return false; // No conflicts
    } catch (error) {
      console.error('Error checking overlap:', error);
      return false;
    }
  };

  const checkOperatorTimeOverlap1 = async (deviceId, fromEpoch, toEpoch) => {
    try {
      // Get all existing operator assignments for this device, not just within the new time range


      const response = await telemetrykeydata(deviceId, 'DEVICE', 'live_component', 0, Date.now());

      const existingData = response?.live_component || [];

      for (const item of existingData) {
        if (!item?.value) continue;

        let parsed = {};
        try {
          parsed = JSON.parse(item.value);
        } catch (e) {
          continue;
        }

        const existingStart = parsed.start_time || item.ts;
        const existingEnd = parsed.end_time || (existingStart + (parsed.duration || 0) * 1000);

        // Check overlap: if the new time range overlaps with any existing assignment
        const isOverlapping = fromEpoch < existingEnd && existingStart < toEpoch;
        if (isOverlapping) {
          console.log('Overlap detected:', {
            newStart: new Date(fromEpoch),
            newEnd: new Date(toEpoch),
            existingStart: new Date(existingStart),
            existingEnd: new Date(existingEnd),
            operator: parsed.name
          });
          return true;
        }
      }

      return false;
    } catch (error) {
      console.error('Error checking overlap:', error);
      return false;
    }
  };
  // const handleEndTimeChange = async (value) => {
  //   if (dayjs(value).isSame(startTime, 'second')) {
  //     setOpenEditDialog(false);
  //     setOpenEditDialog1(false);
  //     setOpenEditDialog4(false);
  //     Swal.fire('Error', 'Start Time and End Time cannot be the same!', 'error');
  //     return;
  //   }
  //   // if (!value || !isTimeInShift(value, selectedShiftData)) {
  //   //   setOpenEditDialog(false);
  //   //   setOpenEditDialog1(false);
  //   //   setOpenEditDialog4(false);
  //   //   Swal.fire('Error', 'Selected time is outside the shift range!', 'error');
  //   //   return;
  //   // }


  //   setEndTime(value);

  //   if (startTime) {
  //     await validateAndCheckOverlap(startTime, value);
  //   }
  // };
  // const handleEndTimeChange1 = async (value) => {
  //   if (dayjs(value).isSame(startTime, 'second')) {
  //     setOpenEditDialog(false);
  //     setOpenEditDialog1(false);
  //     setOpenEditDialog4(false);
  //     Swal.fire('Error', 'Start Time and End Time cannot be the same!', 'error');
  //     return;
  //   }
  //   // if (!value || !isTimeInShift(value, selectedShiftData)) {
  //   //   setOpenEditDialog(false);
  //   //   setOpenEditDialog1(false);
  //   //   setOpenEditDialog4(false);
  //   //   Swal.fire('Error', 'Selected time is outside the shift range!', 'error');
  //   //   return;
  //   // }

  //   setEndTime(value);

  //   if (startTime) {
  //     await validateAndCheckOverlap(startTime, value);
  //   }
  // };

  const cancelComponentModal = () => {
    setOpenEditDialog1(false);
    setEndDate(dayjs());
  }

  const handleDateChange = (newValue) => {
    const dayjsVal = dayjs(newValue);
    setSelectedDate(dayjsVal);

    if (!endDate || dayjs(dayjsVal).isAfter(dayjs(endDate))) {
      setEndDate(dayjsVal);
    }

    // Recalculate epoch range when date changes
    if (selectedShift && shifts.length > 0) {
      const { fromEpoch, toEpoch } = getEpochFromShift(selectedShift, dayjsVal);
      setEpochRange({ from: fromEpoch, to: toEpoch });
      const key = 'alloperator';
      customerbasedshift(customerId, key)
        .then(async (data) => {
          const allOperators = data[0]?.value || [];
          setoperatorslist(allOperators);

          const operatorOptions = allOperators
            .filter(shift => shift.mode === "Operator")
            .map(shift => ({
              id: shift.operatorid,
              value: shift.operatorid,
              label: `${shift.operatorid} - ${shift.operatorname}`,
              name: shift.operatorname
            }));

          setoperators(operatorOptions);

          const key2 = 'live_operator';
          const entitytype = 'DEVICE';
          const deviceid = selectedDeviceId;

          try {
            const response = await telemetrykeydata(deviceid, entitytype, key2, fromEpoch, toEpoch);
            if (response && response.live_operator && response.live_operator.length > 0 && response.live_operator[0].value) {
              const parsedValue = JSON.parse(response.live_operator[0].value);
              const operatorCode = parsedValue.code || '';

              const foundOperator = allOperators.find(op => op.operatorid === operatorCode);
              if (foundOperator) {
                setSelectedOperatorId(foundOperator.operatorid);
                setOperatorName(foundOperator.operatorname);
              } else {
                setSelectedOperatorId('');
                setOperatorName('');
              }
            } else {
              setSelectedOperatorId('');
              setOperatorName('');
            }
          } catch (error) {
            console.error('Error fetching live_operator:', error);
            setSelectedOperatorId('');
            setOperatorName('');
          }
        })
        .catch(error => {
          console.error("Error fetching operators:", error);
        });
    }
  };
  const handleOperatorChange = (event, newValue) => {
    if (newValue) {
      setSelectedOperatorId(newValue.id);
      setOperatorName(newValue.name || '');
    } else {
      setSelectedOperatorId('');
      setOperatorName('');
    }
  };

  const handleOperatorChange1 = (newValue) => {
    const dayjsVal = dayjs(newValue);
    setSelectedDate(dayjsVal);
    handleShiftChange(selectedShift, dayjsVal);
  };

  const handleEndDate = (newValue) => {
    const dayjsVal = dayjs(newValue);
    setEndDate(dayjsVal);
    if (selectedDate && endDate && dayjsVal.isBefore(selectedDate, 'day')) {
      setSelectedDate(dayjsVal);
    }

  };

  const handleShiftChange = (shiftValue, dateParam) => {

    const now = dayjs();
    const selectedDateLocal = dateParam || selectedDate;
    const isToday = selectedDateLocal.isSame(now, 'day');
    const currentShiftData = getCurrentShift(shifts, now);
    const selectedShiftData = shifts.find(shift => shift.shift_no === shiftValue);
    setSelectedShift(shiftValue);
    if (isToday && currentShiftData && currentShiftData.shift_no === shiftValue) {
      const currentTimeRounded = now.startOf('minute');
      setStartTime(currentTimeRounded);
      setEndTime(dayjs(currentShiftData.end_time, 'HH:mm:ss'));
    }
    else if (selectedShiftData) {
      setStartTime(dayjs(selectedShiftData.start_time, 'HH:mm:ss'));
      setEndTime(dayjs(selectedShiftData.end_time, 'HH:mm:ss'));
    }
    const { fromEpoch, toEpoch } = getEpochFromShift(shiftValue, selectedDateLocal);
    setEpochRange({ from: fromEpoch, to: toEpoch });
  };
  const operatorvaluechange = async (shiftValue) => {
    try {
      setSelectedShift(shiftValue);
      const { fromEpoch, toEpoch } = getEpochFromShift(shiftValue, selectedDate);
      setEpochRange({ from: fromEpoch, to: toEpoch });

      const key = 'alloperator';
      const operatorData = await customerbasedshift(customerId, key);
      const allOperators = operatorData[0]?.value || [];
      setoperatorslist(allOperators);

      const operatorOptions = allOperators
        .filter(shift => shift.mode === "Operator")
        .map(shift => ({
          id: shift.operatorid,
          value: shift.operatorid,
          label: `${shift.operatorid} - ${shift.operatorname}`,
          name: shift.operatorname
        }));

      setoperators(operatorOptions);

      const key2 = 'live_operator';
      const entitytype = 'DEVICE';
      const deviceId = selectedDeviceId;

      try {
        const response = await telemetrykeydata(deviceId, entitytype, key2, fromEpoch, toEpoch);
        if (response && response.live_operator && response.live_operator.length > 0 && response.live_operator[0].value) {
          const parsedValue = JSON.parse(response.live_operator[0].value);
          const operatorName = parsedValue.operator || '';
          const operatorCode = parsedValue.code || '';

          const foundOperator = allOperators.find(op =>
            op.operatorid === operatorCode || op.operatorname === operatorName
          );

          if (foundOperator) {
            setSelectedOperatorId(foundOperator.operatorid);
            setOperatorName(foundOperator.operatorname);
          } else {
            setSelectedOperatorId('');
            setOperatorName('');
          }
        } else {
          setSelectedOperatorId('');
          setOperatorName('');
        }
      } catch (error) {
        console.error('Error fetching live_operator:', error);
        setSelectedOperatorId('');
        setOperatorName('');
      }
      setOpenEditDialog(true);
    } catch (error) {
      console.error('Error in operatorvaluechange:', error);
    }
  };
  const operatorvaluechange1 = async (shiftValue) => {
    try {
      setSelectedShift(shiftValue);
      setSelectedProcess('');
      const { fromEpoch, toEpoch } = getEpochFromShift(shiftValue, selectedDate);
      setEpochRange({ from: fromEpoch, to: toEpoch });

      const key = 'component';
      const operatorData = await customerbasedshift(customerId, key);
      const allComponents = operatorData[0]?.value || [];
      setcomponentslist(allComponents);
      const componentOptions = allComponents.map(comp => ({
        id: comp.id,
        process_name: comp.process_name ? comp.process_name : null,
        value: comp.component_name,
        label:
          cleanCustomerId(customerId) === window._env_.ATECH_CUSTOMER_ID ||
            cleanCustomerId(customerId) === window._env_.HITECH_CUSTOMER_ID
            ? `${comp.component_number} - ${comp.component_name.length > 15
              ? comp.component_name.slice(0, 15) + "..."
              : comp.component_name
            }${comp.operation_type ? ` (${comp.operation_type})` : ""}`
            : cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID
              ? (() => {
                let label = comp.component_name || "";
                if (comp.item_code) label += ` - ${comp.item_code}`;
                if (comp.operation_number) label += ` (${comp.operation_number})`;
                return label.trim();
              })()
              : `${comp.component_number} - ${comp.component_name}`
      }));
      setcomponents(componentOptions);
      const key2 = 'live_component';
      const entitytype = 'DEVICE';
      const deviceId = selectedDeviceId;

      try {
        const response = await telemetrykeydata(deviceId, entitytype, key2, fromEpoch, toEpoch);
        if (response?.live_component?.[0]?.value) {
          const parsedValue = JSON.parse(response.live_component[0].value);
          const componentName = parsedValue.component_name || '';
          setselectedcomponent(componentName);
          const foundComponent = allComponents.find(comp => comp.component_name === componentName);
          setSelectedComponentId(foundComponent?.id || '');
        } else {
          setselectedcomponent('');
          setSelectedComponentId('');
        }
      } catch (error) {
        console.error('Error fetching live_component:', error);
        setselectedcomponent('');
        setSelectedComponentId('');
      }

      setOpenEditDialog1(true);
    } catch (error) {
      console.error('Error in operatorvaluechange1:', error);
    }
  };
  const operatorvaluechange2 = async (shiftValue) => {
    try {
      setSelectedShift(shiftValue);

      const { fromEpoch, toEpoch } = getEpochFromShift(shiftValue, selectedDate);
      setEpochRange({ from: fromEpoch, to: toEpoch });

      const key = 'alloperator';
      customerbasedshift(customerId, key)
        .then(async (data) => {
          const allShifts = data[0]?.value || [];
          setsupervisorslist(allShifts);
          console.log('allsupervisor', allShifts);

          // ✅ Filter only "Operator" mode
          const operatorNames = allShifts
            .filter(shift => shift.mode === "Supervisor")  // <-- filter added
            .map(shift => ({
              value: shift.operatorname,
              label: `${shift.operatorid} - ${shift.operatorname}`
            }));

          setsupervisors(operatorNames);
          const key2 = 'live_supervisor';
          const entitytype = 'CUSTOMER';
          const cleancustomerid = cleanCustomerId(customerId);

          try {
            const response = await telemetrylatestdata(cleancustomerid, entitytype, key2);
            if (response && response.live_supervisor && response.live_supervisor.length > 0 && response.live_supervisor[0].value) {
              let operator = JSON.parse(response.live_supervisor[0].value).supervisor;
              setselectedsupervisor(operator);
            } else {
              setselectedsupervisor('');
            }
          } catch (error) {

            setselectedsupervisor('');
          }
          setOpenEditDialog4(true);
        })
        .catch(error => {
          console.error("Error fetching shifts:", error);
        });

      setOpenEditDialog4(true);
    } catch (error) {
      console.error('Error in operatorvaluechange1:', error);
    }
  };
  const handleFormChange = (event) => {
    const { name, value } = event.target;
    setselectedoperator(value);
  };
  const handleFormChange3 = (event) => {
    const { name, value } = event.target;
    setselectedsupervisor(value);
  };
  const handleOpenEditDialog = async (devicename, deviceid) => {
    setLoading(true);

    const key1 = 'allShift';

    try {
      const shiftData = await customerbasedshift(customerId, key1);
      const allShifts = shiftData[0]?.value || [];
      setShifts(allShifts);

      const options = allShifts.map((shift) => ({
        value: shift.shift_no,
        label: `Shift${shift.shift_no}`,
      }));
      setShiftOptions(options);

      const now = dayjs();
      const firstShiftLocal = [...allShifts].sort((a, b) => Number(a.shift_no) - Number(b.shift_no))[0];
      const [h, m] = firstShiftLocal ? firstShiftLocal.start_time.split(':').map(Number) : [0, 0];
      const isBeforeFirstShiftLocal = firstShiftLocal ? (now.hour() * 60 + now.minute() < h * 60 + m) : false;

      const currentShiftData = getCurrentShift(allShifts, now);
      const fallbackShiftData = allShifts[0];
      if (currentShiftData) {
        const currentTimeRounded = dayjs().startOf('minute');
        setStartTime(currentTimeRounded);
        setEndTime(dayjs(currentShiftData.end_time, 'HH:mm:ss'));
      } else if (fallbackShiftData) {
        setStartTime(dayjs(fallbackShiftData.start_time, 'HH:mm:ss'));
        setEndTime(dayjs(fallbackShiftData.end_time, 'HH:mm:ss'));
      }
      if (options.length > 0) {
        const defaultShift = options[0].value;
        const initialDate = isBeforeFirstShiftLocal ? dayjs().subtract(1, 'day') : now;
        setSelectedDate(initialDate);
        setEndDate(initialDate);
        const selectedShiftNo = isBeforeFirstShiftLocal
          ? (allShifts.length > 0 ? allShifts[allShifts.length - 1].shift_no : fallbackShiftData?.shift_no)
          : (currentShiftData ? currentShiftData.shift_no : fallbackShiftData?.shift_no);
        setSelectedShift(selectedShiftNo);
        setfilteredResult([]); // (Optional) clear table

        // Calculate initial epoch range for current date and first shift
        const { fromEpoch, toEpoch } = getEpochFromShift(selectedShiftNo, initialDate);
        setEpochRange({ from: fromEpoch, to: toEpoch });
        console.log('fromEpoch:', fromEpoch, 'toEpoch:', toEpoch, 'defaultShift:', defaultShift, 'currentDate:', dayjs());

        setfilteredResult([]);

        // Get operator data
        const key = 'alloperator';
        const operatorData = await customerbasedshift(customerId, key);
        const allOperators = operatorData[0]?.value || [];
        setoperatorslist(allOperators);

        const operatorOptions = allOperators
          .filter((shift) => shift.mode === "Operator")
          .map((shift) => ({
            id: shift.operatorid,
            value: shift.operatorid,
            label: `${shift.operatorid} - ${shift.operatorname}`,
            name: shift.operatorname
          }));
        setoperators(operatorOptions);

        // ✅ Now safely fetch live_operator after all data is ready
        setSelectedDeviceId(deviceid);
        setSelectedDevicename(devicename);
        const key2 = 'live_operator';
        const entitytype = 'DEVICE';

        await fetchLiveOperator(deviceid, entitytype, key2, fromEpoch, toEpoch);
        setOpenEditDialog(true);
      }
    } catch (err) {
      console.error('Error in handleOpenEditDialog:', err);
    } finally {
      setLoading(false);
    }
  };
  const fetchLiveOperator = async (deviceid, entitytype, key2, fromEpoch, toEpoch) => {
    try {
      const response = await telemetrykeydata(deviceid, entitytype, key2, fromEpoch, toEpoch);
      if (
        response &&
        response.live_operator &&
        response.live_operator.length > 0 &&
        response.live_operator[0].value
      ) {
        const parsedValue = JSON.parse(response.live_operator[0].value);
        const operatorName = parsedValue.operator || '';
        const operatorCode = parsedValue.code || '';

        // Find operator by code (operatorid) or name
        const foundOperator = operatorslist.find(op =>
          op.operatorid === operatorCode || op.operatorname === operatorName
        );

        if (foundOperator) {
          setSelectedOperatorId(foundOperator.operatorid);
          setOperatorName(foundOperator.operatorname);
        } else {
          setSelectedOperatorId('');
          setOperatorName('');
        }
      } else {
        setSelectedOperatorId('');
        setOperatorName('');
      }
    } catch (error) {
      console.error('Error fetching live_operator:', error);
      setSelectedOperatorId('');
      setOperatorName('');
    }
  };
  const fetchProcessGroups = async () => {
    const key = 'processgroups';
    try {
      const data = await customerbasedshift(customerId, key);
      const allProcessGroups = data[0]?.value || [];
      const mappedGroups = allProcessGroups.map((item) => ({
        value: item.groupName,
        label: item.groupName,
      }));
      setProcessGroupOptions(mappedGroups);
    } catch (error) {
      console.error("Error fetching reason groups:", error);
      setProcessGroupOptions([]);
    }
  };
  const handleOpenEditDialog1 = async (devicename, deviceid) => {
    if (cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID) {
      await fetchProcessGroups();
    }
    setTimeErrors({ startTime: '', endTime: '' });
    setSelectedProcess('');
    setLoading(true);
    const key1 = 'allShift';
    try {
      const shiftData = await customerbasedshift(customerId, key1);
      const allShifts = shiftData[0]?.value || [];
      setShifts(allShifts);
      const options = [
        { value: 'ALL', label: 'All Shifts' },
        ...allShifts.map((shift) => ({
          value: shift.shift_no,
          label: `Shift ${shift.shift_no}`,
        })),
      ];

      setShiftOptions(options);

      const now = dayjs();
      const firstShiftLocal = [...allShifts].sort((a, b) => Number(a.shift_no) - Number(b.shift_no))[0];
      const [h, m] = firstShiftLocal ? firstShiftLocal.start_time.split(':').map(Number) : [0, 0];
      const isBeforeFirstShiftLocal = firstShiftLocal ? (now.hour() * 60 + now.minute() < h * 60 + m) : false;

      const currentShiftData = getCurrentShift(allShifts, now);
      const fallbackShiftData = allShifts[0];
      if (currentShiftData) {
        const currentTimeRounded = dayjs().startOf('minute');
        setStartTime(currentTimeRounded);
        setEndTime(dayjs(currentShiftData.end_time, 'HH:mm:ss'));
      } else if (fallbackShiftData) {
        setStartTime(dayjs(fallbackShiftData.start_time, 'HH:mm:ss'));
        setEndTime(dayjs(fallbackShiftData.end_time, 'HH:mm:ss'));
      }
      if (options.length > 0) {
        const initialDate = isBeforeFirstShiftLocal ? dayjs().subtract(1, 'day') : now;
        setSelectedDate(initialDate);
        setEndDate(initialDate);
        const selectedShiftNo = isBeforeFirstShiftLocal
          ? (allShifts.length > 0 ? allShifts[allShifts.length - 1].shift_no : fallbackShiftData?.shift_no)
          : (currentShiftData ? currentShiftData.shift_no : fallbackShiftData?.shift_no);
        setSelectedShift(selectedShiftNo);
        setfilteredResult([]);
        const { fromEpoch, toEpoch } = getEpochFromShift(selectedShiftNo, initialDate);
        setEpochRange({ from: fromEpoch, to: toEpoch });

        const key = 'component';
        const operatorData = await customerbasedshift(customerId, key);
        const allComponents = operatorData[0]?.value || [];
        setcomponentslist(allComponents);
        const componentOptions = allComponents.map(comp => ({
          id: comp.id,
          value: comp.component_name,
          process_name: comp.process_name ? comp.process_name : null,
          label:
            cleanCustomerId(customerId) === window._env_.ATECH_CUSTOMER_ID ||
              cleanCustomerId(customerId) === window._env_.HITECH_CUSTOMER_ID
              ? `${comp.component_number} - ${comp.component_name.length > 15
                ? comp.component_name.slice(0, 15) + "..."
                : comp.component_name
              }${comp.operation_type ? ` (${comp.operation_type})` : ""}`
              : cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID
                ? (() => {
                  let label = comp.component_name || "";
                  if (comp.item_code) label += ` - ${comp.item_code}`;
                  if (comp.operation_number) label += ` (${comp.operation_number})`;
                  return label.trim();
                })()
                : `${comp.component_number} - ${comp.component_name}`
        }));
        setcomponents(componentOptions);

        setSelectedDeviceId(deviceid);
        setSelectedDevicename(devicename);
        const key2 = 'live_component';
        const entitytype = 'DEVICE';
        await fetchLiveComponent(deviceid, entitytype, key2, fromEpoch, toEpoch);
        setOpenEditDialog1(true);
      }
    } catch (err) {
      console.error('Error in handleOpenEditDialog:', err);
    } finally {
      setLoading(false);
    }
  };
  const fetchLiveComponent = async (deviceid, entitytype, key2, fromEpoch, toEpoch) => {
    try {
      const response = await telemetrykeydata(deviceid, entitytype, key2, fromEpoch, toEpoch);
      if (response && response.live_component && response.live_component.length > 0 && response.live_component[0].value) {
        const data = JSON.parse(response.live_component[0].value);
        const componentName = data.component_name || '';
        setselectedcomponent(componentName);
        const foundComponent = componentslist.find(comp => comp.component_name === componentName);
        if (foundComponent) {
          setSelectedComponentId(foundComponent.id);
        } else {
          setSelectedComponentId('');
        }
      } else {
        setselectedcomponent('');
        setSelectedComponentId('');
      }
    } catch (error) {
      console.error('Error fetching live_component:', error);
      setselectedcomponent('');
      setSelectedComponentId('');
    }
  };
  const handleOpenEditDialog2 = async (devicename, deviceid) => {
    const key = 'reason';
    const customerId = localStorage.getItem('CustomerID');
    customerbasedshift(customerId, key)
      .then(async (data) => {
        const allShifts = data[0]?.value || [];
        setreasonslist(allShifts);
        const reasons = allShifts.map(shift => ({
          value: shift.reason,
          label: shift.reason,
          group: shift.group || null
        }));
        setreasons(reasons);
        setSelectedDeviceId(deviceid);
        setOpenEditDialog2(true);
        //downtimereason();
      })
      .catch(error => {
        console.error("Error fetching shifts:", error);
      });
    const key1 = 'allShift';

    // Fetch shifts and set shift options
    customerbasedshift(customerId, key1)
      .then(async (data) => {
        const allShifts = data[0].value || [];
        setShifts(allShifts);

        const options = allShifts.map((shift) => ({
          value: shift.shift_no,
          label: `Shift${shift.shift_no}`,
        }));
        setShiftOptions(options);
        const selectedShiftData = allShifts.find(shift => shift.shift_no === allShifts[0]?.shift_no || '1');
        if (selectedShiftData) {
          setStartTime(dayjs(selectedShiftData.start_time, 'HH:mm:ss'));
          setEndTime(dayjs(selectedShiftData.end_time, 'HH:mm:ss'));
        }
        if (options.length > 0) {
          const defaultShift = options[0].value;
          setSelectedDate(dayjs()); // Set to current date
          setSelectedShift(defaultShift);
          setfilteredResult([]); // (Optional) clear table

          // Calculate initial epoch range for current date and first shift
          const { fromEpoch, toEpoch } = getEpochFromShift(defaultShift, dayjs());
          setEpochRange({ from: fromEpoch, to: toEpoch });
        }
      })
      .catch((err) => {
        console.error('Error loading shifts:', err);
      })
      .finally(() => setLoading(false));
  };
  const handleOpenEditDialog4 = async () => {
    const key1 = 'allShift';
    const shiftData = await customerbasedshift(customerId, key1);
    const allShifts = shiftData[0]?.value || [];
    setShifts(allShifts);

    const options = allShifts.map((shift) => ({
      value: shift.shift_no,
      label: `Shift${shift.shift_no}`,
    }));
    setShiftOptions(options);
    const now = dayjs();
    const firstShiftLocal = [...allShifts].sort((a, b) => Number(a.shift_no) - Number(b.shift_no))[0];
    const [h, m] = firstShiftLocal ? firstShiftLocal.start_time.split(':').map(Number) : [0, 0];
    const isBeforeFirstShiftLocal = firstShiftLocal ? (now.hour() * 60 + now.minute() < h * 60 + m) : false;

    const currentShiftData = getCurrentShift(allShifts, now);
    const fallbackShiftData = allShifts[0];
    if (currentShiftData) {
      const currentTimeRounded = dayjs().startOf('minute');
      setStartTime(currentTimeRounded);
      setEndTime(dayjs(currentShiftData.end_time, 'HH:mm:ss'));
    } else if (fallbackShiftData) {
      setStartTime(dayjs(fallbackShiftData.start_time, 'HH:mm:ss'));
      setEndTime(dayjs(fallbackShiftData.end_time, 'HH:mm:ss'));
    }
    if (options.length > 0) {
      const initialDate = isBeforeFirstShiftLocal ? dayjs().subtract(1, 'day') : now;
      setSelectedDate(initialDate);
      setEndDate(initialDate);
      const selectedShiftNo = isBeforeFirstShiftLocal
        ? (allShifts.length > 0 ? allShifts[allShifts.length - 1].shift_no : fallbackShiftData?.shift_no)
        : (currentShiftData ? currentShiftData.shift_no : fallbackShiftData?.shift_no);
      setSelectedShift(selectedShiftNo);
      setfilteredResult([]); // (Optional) clear table

      // Calculate initial epoch range for current date and first shift
      const { fromEpoch, toEpoch } = getEpochFromShift(selectedShiftNo, initialDate);
      setEpochRange({ from: fromEpoch, to: toEpoch });
      console.log('fromEpoch:', fromEpoch, 'toEpoch:', toEpoch, 'selectedShiftNo:', selectedShiftNo, 'initialDate:', initialDate);

      setfilteredResult([]);


      const key = 'alloperator';
      customerbasedshift(customerId, key)
        .then(async (data) => {
          const allShifts = data[0]?.value || [];
          setsupervisorslist(allShifts);
          console.log('allsupervisor', allShifts);

          // ✅ Filter only "Operator" mode
          const operatorNames = allShifts
            .filter(shift => shift.mode === "Supervisor")  // <-- filter added
            .map(shift => ({
              value: shift.operatorname,
              label: `${shift.operatorid} - ${shift.operatorname}`
            }));

          setsupervisors(operatorNames);
          const key2 = 'live_supervisor';
          const entitytype = 'CUSTOMER';
          const cleancustomerid = cleanCustomerId(customerId);

          try {
            const response = await telemetrylatestdata(cleancustomerid, entitytype, key2);
            if (response && response.live_supervisor && response.live_supervisor.length > 0 && response.live_supervisor[0].value) {
              let operator = JSON.parse(response.live_supervisor[0].value).supervisor;
              setselectedsupervisor(operator);
            } else {
              setselectedsupervisor('');
            }
          } catch (error) {

            setselectedsupervisor('');

          }
          setOpenEditDialog4(true);
        })
        .catch(error => {
          console.error("Error fetching shifts:", error);
        });
    }

  }
  const handleSaveThreshold3 = async () => {
    if (savingStates.supervisor) return;
    setSavingStates(prev => ({ ...prev, supervisor: true }));
    try {
      const dateError = validateDate(selectedDate);
      if (dateError) {
        setDateErrors(prev => ({ ...prev, supervisor: dateError }));
        Swal.fire('Error', dateError, 'error');
        return;
      }
      const startError = validateStartTime(startTime);
      const endError = validateEndTime(endTime);
      if (startError || endError) {
        setTimeErrors({ startTime: startError, endTime: endError });
        Swal.fire('Error', 'Please fix time validation errors.', 'error');
        return;
      }

      if (!selectedShift || !selectedDate || !supervisorselected) {
        Swal.fire('Error', 'Please fill all required fields.', 'error');
        return;
      }

      const selectedShiftData = shifts.find(shift => shift.shift_no === selectedShift);
      if (!selectedShiftData) {
        Swal.fire('Error', 'Selected shift not found.', 'error');
        return;
      }
      const fromDateTime = getAdjustedDateTime(startTime, selectedDate, selectedShiftData);
      const toDateTime = getAdjustedDateTime(endTime, selectedDate, selectedShiftData);
      if (!fromDateTime || !toDateTime) {
        Swal.fire('Error', 'Invalid time selection. Please check start and end times.', 'error');
        return;
      }
      const fromEpoch = fromDateTime.valueOf();
      const toEpoch = toDateTime.valueOf();
      if (fromEpoch >= toEpoch) {
        Swal.fire('Error', 'Start time must be before end time.', 'error');
        return;
      }

      const durations = Math.floor((toEpoch - fromEpoch) / 1000);
      const shiftEpoch = getEpochFromShift(selectedShift, selectedDate);
      const fromtime = shiftEpoch.fromEpoch;
      const totime = shiftEpoch.toEpoch;

      if (!fromtime || !totime) {
        Swal.fire('Error', 'Unable to determine shift boundaries.', 'error');
        return;
      }
      const cleancustomerid1 = cleanCustomerId(customerId);
      // 🔍 Check for overlap before saving
      const response = await telemetrykeydata(
        cleancustomerid1,
        'CUSTOMER',
        'live_supervisor',
        fromtime,
        totime
      );

      const existingEntries = response?.live_supervisor || [];
      console.log('existingdatas', existingEntries)
      for (const item of existingEntries) {
        if (!item?.value) continue;

        let parsed;
        try {
          parsed = JSON.parse(item.value);
        } catch (e) {
          continue;
        }

        const existingStart = parsed.start_time || item.ts;
        const existingEnd =
          parsed.end_time ||
          (existingStart + (parsed.duration || 0) * 1000);

        const isOverlapping = fromEpoch < existingEnd && existingStart < toEpoch;

        if (isOverlapping) {
          const existingOperator = parsed.name || 'Unknown';
          const conflictStart = dayjs(existingStart).format('DD-MM-YYYY HH:mm:ss');
          const conflictEnd = dayjs(existingEnd).format('DD-MM-YYYY HH:mm:ss');

          Swal.fire({
            icon: 'error',
            title: 'Error',
            html: `Time overlaps with existing supervisor "<strong>${existingOperator}</strong>" between <strong>${conflictStart}</strong> and <strong>${conflictEnd}</strong>.`,
            showCancelButton: true,
            confirmButtonText: 'Overwrite',
            cancelButtonText: 'No, Cancel',
            backdrop: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false
          }).then((result1) => {
            if (result1.isConfirmed) {
              // Only show the second confirmation if user clicked "Overwrite"
              Swal.fire({
                title: 'Do you want to overwrite the existing supervisor allocation with the new changes?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Yes, Save',
                cancelButtonText: 'No, Cancel',
                backdrop: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false
              }).then(async (result2) => {
                if (result2.isConfirmed) {
                  try {
                    const cleancustomerid1 = cleanCustomerId(customerId);

                    // First delete existing data in the time range
                    const deleteResponse = await DowntimeaddDelete1('CUSTOMER', cleancustomerid1, 'live_supervisor', fromtime, totime);

                    if (deleteResponse !== true) {
                      throw new Error('Failed to delete existing data for the specified time range.');
                    }
                    else {
                      const operator = supervisorslist.find(op => op.operatorname === supervisorselected);
                      const opertorid = operator ? operator.operatorid : null;

                      const key = {
                        ts: fromEpoch,
                        values: {
                          live_supervisor: {
                            name: supervisorselected,
                            code: opertorid,
                            start_time: fromEpoch,
                            end_time: toEpoch,
                            duration: durations
                          }
                        }
                      };
                      const cleancustomerid = cleanCustomerId(customerId);
                      await Downtimeadd2('CUSTOMER', cleancustomerid, 'SERVER_SCOPE', key);


                      Swal.fire({
                        title: 'Success',
                        text: 'Supervisor assigned successfully.',
                        icon: 'success',
                        backdrop: true,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false
                      });

                      setTimeout(() => {
                        handleSubmit();
                      }, 2000);
                    }
                    // Then proceed to add new operator data

                  } catch (error) {
                    console.error('Error in supervisor allocation update:', error);
                    Swal.fire({
                      title: 'Error',
                      text: error.message || 'Failed to update supervisor allocation.',
                      icon: 'error',
                      backdrop: true,
                      allowOutsideClick: false,
                      allowEscapeKey: false,
                      allowEnterKey: false
                    });
                  }
                } else {
                  console.log("User cancelled save.");
                }
              });
            } else {
              console.log("User cancelled overwrite.");
            }
          });


          return;
        }
      }

      // ✅ Proceed to save if no overlap
      const operator = supervisorslist.find(op => op.operatorname === supervisorselected);
      const opertorid = operator ? operator.operatorid : null;
      const key = {
        ts: fromEpoch,
        values: {
          live_supervisor: {
            name: supervisorselected,
            code: opertorid,
            start_time: fromEpoch,
            end_time: toEpoch,
            duration: durations
          }
        }
      };

      const cleancustomerid = cleanCustomerId(customerId);
      await Downtimeadd2('CUSTOMER', cleancustomerid, 'SERVER_SCOPE', key);

      Swal.fire('Success', 'Supervisor assigned successfully.', 'success');
      setTimeout(() => {
        handleSubmit();
      }, 2000);
    } catch (err) {
      console.error('Update error:', err);
      Swal.fire('Error', 'Failed to assign Supervisor.', 'error');
    } finally {
      setSavingStates(prev => ({ ...prev, supervisor: false }));
      setOpenEditDialog4(false);
    }
  }
  const cancelreason = async () => {
    setOpenEditDialog2(false);

  }

  const getEpochFromShift2 = (shiftNo, selectedDateObj, shifts) => {
    if (!shiftNo || !selectedDateObj || !shifts || shifts.length === 0) {
      return { fromEpoch: null, toEpoch: null };
    }
    const selectedShiftData = shifts.find(shift => String(shift.shift_no) === String(shiftNo));
    if (!selectedShiftData) {
      return { fromEpoch: null, toEpoch: null };
    }
    const dateStr = selectedDateObj.format("YYYY-MM-DD");
    const startDateTime = dayjs(`${dateStr}T${selectedShiftData.start_time}`);
    let endDateTime;
    if (selectedShiftData.end_day !== selectedShiftData.start_day) {
      const nextDay = selectedDateObj.add(1, "day").format("YYYY-MM-DD");
      endDateTime = dayjs(`${nextDay}T${selectedShiftData.end_time}`);
    } else {
      endDateTime = dayjs(`${dateStr}T${selectedShiftData.end_time}`);
    }
    return {
      fromEpoch: startDateTime.valueOf(),
      toEpoch: endDateTime.valueOf(),
    };
  };

  function getShiftTimes(shifts, selectedShift, selectedDate) {
    if (!Array.isArray(shifts) || shifts.length === 0 || !selectedDate) {
      return { from: null, to: null };
    }
    const selectedStr = dayjs(selectedDate).format("YYYY-MM-DD");
    const getDateByDayOffset = (baseDate, dayValue) => {
      const offset = Number(dayValue) - 1; // 1 = same day, 2 = +1 day, etc.
      return dayjs(baseDate).add(offset, "day").format("YYYY-MM-DD");
    };
    const normalizedShift =
      typeof selectedShift === "string"
        ? selectedShift.trim().toLowerCase()
        : selectedShift == null
          ? ""
          : String(selectedShift);
    if (normalizedShift === "") return { from: null, to: null };
    if (normalizedShift === "allshift" || normalizedShift === "all shift") {
      const sortedShifts = [...shifts].sort(
        (a, b) => Number(a.shift_no) - Number(b.shift_no)
      );
      const firstShift = sortedShifts[0];
      const lastShift = sortedShifts[sortedShifts.length - 1];
      if (!firstShift || !lastShift) return { from: null, to: null };
      const fromDateStr = getDateByDayOffset(selectedStr, firstShift.start_day);
      const toDateStr = getDateByDayOffset(selectedStr, lastShift.end_day);
      const fromStr = `${fromDateStr}T${firstShift.start_time}`;
      const toStr = `${toDateStr}T${lastShift.end_time}`;
      return {
        from: new Date(fromStr).getTime(),
        to: new Date(toStr).getTime(),
      };
    }
    const shiftData = shifts.find((s) => String(s.shift_no) === normalizedShift);
    if (!shiftData) return { from: null, to: null };
    const { start_time, end_time, start_day, end_day } = shiftData;
    const fromDateStr = getDateByDayOffset(selectedStr, start_day);
    const toDateStr = getDateByDayOffset(selectedStr, end_day);
    const fromStr = `${fromDateStr}T${start_time}`;
    const toStr = `${toDateStr}T${end_time}`;
    return {
      fromEpoch: new Date(fromStr).getTime(),
      toEpoch: new Date(toStr).getTime(),
    };
  }

  const downtimereason = async () => {
    if (!selectedDeviceId || !selectedShift || !selectedDate) return;
    await fetchReasonGroups()
    // const { fromEpoch, toEpoch } = getEpochFromShift2(selectedShift, selectedDate, shifts);
    const { fromEpoch, toEpoch } = getShiftTimes(shifts, selectedShift, selectedDate);
    console.log(fromEpoch, toEpoch, 'from and to time')

    if (!fromEpoch || !toEpoch) return;

    const fromTime = fromEpoch;
    const toTime = toEpoch;
    const deviceId = selectedDeviceId;
    try {
      if (deviceId && fromTime && toTime) {
        telemetrykeydata(deviceId, 'DEVICE', 'machine_status', fromTime, toTime)
          .then(async machineStatusResponse => {
            const machineData = machineStatusResponse?.machine_status || [];

            const statusMapping = {
              0: { state: "Idle", color: "#FFEB3B" },
              1: { state: "Idle", color: "#FFEB3B" },
              2: { state: "Idle", color: "#FFEB3B" },
              3: { state: "Run", color: "#4CAF50" },
              100: { state: "Disconnect", color: "#808080" },
              5: { state: "Alarm", color: "#F44336" },
            };

            let runTime = 0, idleTime = 0, disconnectTime = 0, alarmTime = 0;
            const sortedData = [...machineData].sort((a, b) => Number(a.ts) - Number(b.ts));

            for (let i = 0; i < sortedData.length; i++) {
              const currentStatus = sortedData[i].value;
              const currentTs = Number(sortedData[i].ts);

              let nextTs;
              if (i < sortedData.length - 1) {
                nextTs = Number(sortedData[i + 1].ts);
              } else {
                nextTs = Number(toTime);
              }

              const intervalStart = Math.max(currentTs, Number(fromTime));
              const intervalEnd = Math.min(nextTs, Number(toTime));
              const duration = Math.max(0, intervalEnd - intervalStart);

              if (duration > 0) {
                const state = statusMapping[currentStatus]?.state;
                if (state === "Run") {
                  runTime += duration;
                } else if (state === "Idle") {
                  idleTime += duration;
                } else if (state === "Disconnect") {
                  disconnectTime += duration;
                } else if (state === "Alarm") {
                  alarmTime += duration;
                }
              }
            }

            const msToTime = ms => {
              const absMs = Math.abs(ms);
              const hours = Math.floor(absMs / 3600000);
              const minutes = Math.floor((absMs % 3600000) / 60000);
              const seconds = Math.floor((absMs % 60000) / 1000);
              return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
            };



            const transformedData = sortedData
              .filter(item => item.ts && item.value !== undefined)
              .map(item => ({ ts: item.ts, value: item.value }));

            const extractStartEndFromOneToThree = (data) => {
              const result = [];
              let recording = false;
              let segment = { start: null, value: null };
              const IDLE_START_CODES = [0, 1, 2];
              const IDLE_END_CODES = [3, 4, 5, 100];

              for (let i = 0; i < data.length; i++) {
                const current = data[i];
                const numericValue = Number(current.value);

                if (!recording && IDLE_START_CODES.includes(numericValue)) {
                  segment.start = current.ts;
                  segment.value = numericValue;
                  recording = true;
                }

                if (recording && IDLE_END_CODES.includes(numericValue)) {
                  segment.end = current.ts;
                  const duration = Math.floor((segment.end - segment.start) / 1000);

                  result.push({
                    start: segment.start,
                    end: segment.end,
                    duration,
                    value: segment.value,
                    status: 'IDLE',
                  });

                  recording = false;
                  segment = { start: null, value: null };
                }

                if (recording && IDLE_START_CODES.includes(numericValue)) {
                  segment.value = numericValue;
                }
              }

              if (recording) {
                const now = Date.now();
                segment.end = Math.min(toTime, now);
                const duration = Math.floor((segment.end - segment.start) / 1000);
                result.push({
                  start: segment.start,
                  end: segment.end,
                  duration,
                  value: segment.value,
                  status: 'IDLE',
                  ongoing: now < toTime,
                });
              }

              return result.length > 0
                ? result
                : [{ start: fromTime, end: toTime, duration: 0, value: 0, status: 'NO_DATA' }];
            };
            let downtime;
            const key = 'downtime_threasold';
            const results = await Deviceattributeget(deviceId, key);
            let downtimedatas = encodeURIComponent(JSON.stringify([{ start: fromTime, end: toTime, duration: 0, value: 0, status: 'NO_DATA' }]));
            console.log('Result', results);

            if (results && results.length > 0) {
              downtime = results[0].value;
              const result = extractStartEndFromOneToThree(transformedData);
              const filteredResult = result.filter(entry => entry.duration > downtime && !entry.ongoing);
              console.log('filterresult', filteredResult)
              setfilteredResult(filteredResult);
              downtimedatas = encodeURIComponent(JSON.stringify(filteredResult));
            }

            const encodedData = encodeURIComponent(JSON.stringify(transformedData));
            console.log('result', transformedData)

            return Promise.all([
              Promise.resolve(encodedData),
              Promise.resolve(downtimedatas)
            ]);
          })
          .then(async ([encodedData, downtimedatas]) => {
            const downtimedata = downtimedatas;
            console.log('downtimedata', downtimedata);

            const key2 = 'live_reason';
            const entitytype = 'DEVICE';
            const deviceid = deviceId;

            try {
              const response = await telemetrykeydata(deviceid, entitytype, key2, fromEpoch, toEpoch);

              if (
                response &&
                Array.isArray(response.live_reason) &&
                response.live_reason.length > 0
              ) {
                const parsedLiveReasons = response.live_reason.map(entry => {
                  try {
                    const parsedValue = JSON.parse(entry.value);
                    return {
                      ts: entry.ts,
                      ...parsedValue // includes: name, code, mode, module, idle_start
                    };
                  } catch (err) {
                    console.error("Failed to parse live_reason value:", entry.value, err);
                    return null;
                  }
                }).filter(reason => reason !== null);

                // For each item in filteredResult, set reasonselected if match found
                setfilteredResult(prevResults => {
                  return prevResults.map(item => {
                    const matched = parsedLiveReasons.find(reason =>
                      String(reason.ts) === String(item.start)
                    );
                    return {
                      ...item,
                      reasonselected: matched?.name || item.reasonselected || '',
                      groupselected: matched?.group || "all"

                    };
                  });
                });

              } else {
                console.log("No valid live_reason data found");
              }
            } catch (error) {
              console.error("Error while processing live_reason telemetry:", error);
            }


          })


      }
    } catch (error) {
      console.error('Error fetching downtime data:', error);
    } finally {
      setLoading(false);
    }
  };
  const formatEpochToIST = (epoch) => {
    const options = { timeZone: 'Asia/Kolkata' };
    const date = new Date(epoch).toLocaleString('en-US', options);
    const d = new Date(date);

    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();

    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };


  // Format seconds to HH:mm:ss
  const formatDuration = (durationInSeconds) => {
    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);
    const seconds = durationInSeconds % 60;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };
  const handleDateChange1 = (newValue) => {
    const dayjsVal = dayjs(newValue);
    setSelectedDate(dayjsVal);

    // Recalculate epoch range when date changes
    if (selectedShift && shifts.length > 0) {
      const { fromEpoch, toEpoch } = getEpochFromShift(selectedShift, dayjsVal);
      setEpochRange({ from: fromEpoch, to: toEpoch });
      const key = 'alloperator';
      customerbasedshift(customerId, key)
        .then(async (data) => {
          const allShifts = data[0]?.value || [];
          setoperatorslist(allShifts);
          console.log('alloperator', allShifts);

          // ✅ Filter only "Operator" mode
          const operatorNames = allShifts
            .filter(shift => shift.mode === "Operator")  // <-- filter added
            .map(shift => ({
              value: shift.operatorname,
              label: `${shift.operatorid} - ${shift.operatorname}`
            }));

          setoperators(operatorNames);
          const key2 = 'live_operator';
          const entitytype = 'DEVICE';
          const deviceid = selectedDeviceId;

          try {
            const response = await telemetrykeydata(deviceid, entitytype, key2, fromEpoch, toEpoch);
            //const response = await telemetrylatestdata(deviceid, entitytype, key2);
            if (response && response.live_operator && response.live_operator.length > 0 && response.live_operator[0].value) {
              let operator = JSON.parse(response.live_operator[0].value).operator;
              setselectedoperator(operator);
            } else {
              setselectedoperator('');
            }
          } catch (error) {

            setselectedoperator('');
          }
        })
        .catch(error => {
          console.error("Error fetching shifts:", error);
        });
    }
  };
  const handleReasonChange = (index, val) => {
    setfilteredResult(prevResults => {
      const updatedResults = [...prevResults];
      updatedResults[index] = {
        ...updatedResults[index],
        reasonselected: val,
        reasonChanged: true
      };
      return updatedResults;
    });
  };

  const handleGroupChange = (index, selectedGroup) => {
    setfilteredResult(prev => {
      const updated = [...prev];
      updated[index].groupselected = selectedGroup;
      updated[index].reasonselected = "";
      return updated;
    });
  };

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        setIframeInteractive(false);
      }
    };

    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, []);

  useEffect(() => {
    const commonOptions = [
      { value: 'Component', label: 'Component' },
      { value: 'Reason', label: 'Reason' },
      // { value: 'Supervisor', label: 'Supervisor' },
    ];
    const fallbackOptions =
      cleanCustomerId(customerId) === window._env_.CUSTOMER_ID
        ? commonOptions
        : [{ value: 'Operator', label: 'Operator' }, ...commonOptions];

    setSelectedassignmode(fallbackOptions[0].value)
    setAssignmodes(fallbackOptions);
    const fetchDevices = async () => {
      try {
        const devicesData = await customerbaseddevices(customerId1, 100, 0);
        setDevices(devicesData);

        const sortedDevices = (Array.isArray(devicesData?.data) ? devicesData.data : [])
          .sort((a, b) => a.name.localeCompare(b.name));

        const options = sortedDevices.map(device => ({
          value: device.id?.id || '',
          label: device.name || `Device ${device.id?.id || ''}`
        }));

        if (options.length > 0) {
          setdevicename(options[0]?.label || '');
          setSelectedDevicename(options[0]?.label || '');
          setdeviceid(options[0]?.value || '');
          setSelectedDevice(options[0]?.value || '');
        }

        setDeviceOptions(options);
      } catch (error) {
        console.error('Error fetching devices:', error);
      }
    };

    fetchDevices();

    const todayStart = dayjs().startOf('day');
    const todayEnd = dayjs().add(7, 'day').endOf('day');
    setStartDateTime(todayStart);
    setEndDateTime(todayEnd);

    if (Deviceid && token) {
      const fromEpoch = todayStart.valueOf();
      const toEpoch = todayEnd.valueOf();
      const keys = cleanCustomerId(customerId) === window._env_.CUSTOMER_ID ? 'live_component' : 'live_operator';
      const entitytype = 'DEVICE';
      const url = `${window._env_.GRAFANA_URL}d/bef32fe1-8f81-4d8e-94c3-9828fe8ec685/operator-dashboard?orgId=1&var-device_id=${Deviceid}&var-entityType=${entitytype}&var-entityId=${Deviceid}&var-token=${token}&var-key=${keys}&from=${fromEpoch}&to=${toEpoch}&var-url=${window._env_.SERVER_URL.replace(/\/$/, '')}&var-grafanaurl=${window._env_.GRAFANA_URL}&kiosk&theme=${document.body.dataset.theme==='dark'?'dark':'light'}`;
      setIframeUrl(url);
      initialLoad.current = false;
    }
  }, [Deviceid, token, customerId1]);

  const getiframedata = async () => {
    const fallbackOptions = [
      // { value: 'Operator', label: 'Operator' },
      { value: 'Component', label: 'Component' },
      { value: 'Reason', label: 'Reason' },
      { value: 'Supervisor', label: 'Supervisor' },
    ];
    setSelectedassignmode(fallbackOptions[0].value);
    setAssignmodes(fallbackOptions);

    const todayStart = dayjs().startOf('day');
    const todayEnd = dayjs().add(7, 'day').endOf('day');
    setStartDateTime(todayStart);
    setEndDateTime(todayEnd);

    if (token) {
      const fromEpoch = todayStart.valueOf();
      const toEpoch = todayEnd.valueOf();
      let keys;
      let entitytype;
      let entityId;
      let url;

      switch (selectedassignmode) {
        case 'Operator':
          keys = 'live_operator';
          entitytype = 'DEVICE';
          entityId = Deviceid;
          break;
        case 'Supervisor':
          keys = 'live_supervisor';
          entitytype = 'CUSTOMER';
          entityId = cleanCustomerId(customerId);
          break;
        case 'Component':
          keys = 'live_component';
          entitytype = 'DEVICE';
          entityId = Deviceid;
          break;
        case 'Reason':
          keys = 'live_reason';
          entitytype = 'DEVICE';
          entityId = Deviceid;
          break;
        default:
          keys = 'live_component';
          entitytype = 'DEVICE';
          entityId = Deviceid;
      }

      url = `${window._env_.GRAFANA_URL}d/bef32fe1-8f81-4d8e-94c3-9828fe8ec685/operator-dashboard?orgId=1&var-device_id=${entityId}&var-token=${token}&var-key=${keys}&var-entityType=${entitytype}&var-entityId=${entityId}&from=${fromEpoch}&to=${toEpoch}&var-url=${window._env_.SERVER_URL.replace(/\/$/, '')}&var-grafanaurl=${window._env_.GRAFANA_URL}&kiosk&theme=${document.body.dataset.theme==='dark'?'dark':'light'}`;
      setIframeUrl(url);
      initialLoad.current = false;
    }
  };

  const fetchReasonGroups = async () => {
    const key = "reasongroups";
    try {
      const data = await customerbasedshift(customerId, key);
      const allReasonGroups = Array.isArray(data?.[0]?.value)
        ? data[0].value
        : [];
      const mappedGroups = [
        { value: "all", label: "All Groups" },
        ...allReasonGroups.map(item => ({
          value: item.groupName || item.name || "",
          label: item.groupName || item.name || "",
        })),
      ];
      setReasonGroupOptions(mappedGroups);
      return mappedGroups;
    } catch (error) {
      console.error("❌ Error fetching reason groups:", error);
      setReasonGroupOptions([{ value: "", label: "All Groups" }]);
      return [{ value: "", label: "All Groups" }];
    }
  };

  useEffect(() => {
    if (devices.length > 0) {
      fetchAverageUtilizationForAllDevices();
    }
  }, [devices, selectedDevice]);

  const fetchAverageUtilizationForAllDevices = async () => {
    try {
      let devicesToFetch = [];

      if (selectedDevice === 'all') {
        devicesToFetch = devices;
      } else {
        devicesToFetch = devices.filter((device) => device.id?.id === selectedDevice);
      }

      const utilizationList = await Promise.all(
        devicesToFetch.map(async (device) => {
          const deviceId = device.id?.id;
          const deviceName = device.name;

          try {
            const response = await telemetrylatestdata(deviceId, 'DEVICE', 'averageUtilization');
            const value = response?.averageUtilization?.[0]?.value || 0;

            return {
              label: deviceName,
              value: parseFloat(value).toFixed(2).toString()
            };
          } catch (err) {
            console.error(`Error fetching utilization for ${deviceName}`, err);
            return {
              label: deviceName,
              value: '0.00'
            };
          }
        })
      );

      setUtilizationData(utilizationList);
      const formatted = encodeURIComponent(JSON.stringify(utilizationList));
      setFormattedUtilization(formatted);
    } catch (error) {
      console.error('Error fetching utilization for selected devices:', error);
    }
  };

  const handleSubmit = () => {
    if (!token || !startDateTime || !endDateTime || !selectedassignmode) return;

    const fromEpoch = startDateTime.valueOf();
    const toEpoch = endDateTime.valueOf();
    let url;
    let keys;
    let entitytype;
    let entityId;

    if (selectedassignmode === 'Operator') {
      keys = 'live_operator';
      entitytype = 'DEVICE';
      entityId = selectedDevice;
    }
    else if (selectedassignmode === 'Supervisor') {
      keys = 'live_supervisor';
      entitytype = 'CUSTOMER';
      entityId = cleanCustomerId(customerId);
      console.log('Supervisor Submit:', { entityId, entitytype, keys, token, fromEpoch, toEpoch });
    }
    else {
      keys = 'live_component';
      entitytype = 'DEVICE';
      entityId = selectedDevice;
    }

    url = `${window._env_.GRAFANA_URL}d/bef32fe1-8f81-4d8e-94c3-9828fe8ec685/operator-dashboard?orgId=1&var-device_id=${entityId}&var-token=${token}&var-key=${keys}&var-entityType=${entitytype}&var-entityId=${entityId}&from=${fromEpoch}&to=${toEpoch}&var-url=${window._env_.SERVER_URL.replace(/\/$/, '')}&var-grafanaurl=${window._env_.GRAFANA_URL}&kiosk&theme=${document.body.dataset.theme==='dark'?'dark':'light'}`;

    setIframeUrl(url);
    setIframeKey(prevKey => prevKey + 1);
    initialLoad.current = false;
  };
  const isOvernight = (shift) => {
    const start = dayjs(shift.start_time, 'HH:mm:ss');
    const end = dayjs(shift.end_time, 'HH:mm:ss');
    return end.isBefore(start);
  };
  const handleSaveThreshold = async () => {
    if (savingStates.operator) return;
    setSavingStates(prev => ({ ...prev, operator: true }));
    try {
      const dateError = validateDate(selectedDate);
      if (dateError) {
        setDateErrors(prev => ({ ...prev, operator: dateError }));
        Swal.fire('Error', dateError, 'error');
        return;
      }
      const startError = validateStartTime(startTime);
      const endError = validateEndTime(endTime);
      if (startError || endError) {
        setTimeErrors({ startTime: startError, endTime: endError });
        Swal.fire('Error', 'Please fix time validation errors.', 'error');
        return;
      }

      if (!selectedDeviceId || !selectedShift || !selectedDate || !selectedOperatorId) {
        Swal.fire('Error', 'Please fill all required fields.', 'error');
        return;
      }

      const selectedShiftData = shifts.find(shift => shift.shift_no === selectedShift);
      if (!selectedShiftData) {
        Swal.fire('Error', 'Selected shift not found.', 'error');
        return;
      }
      const fromDateTime = getAdjustedDateTime(startTime, selectedDate, selectedShiftData);
      const toDateTime = getAdjustedDateTime(endTime, selectedDate, selectedShiftData);

      if (!fromDateTime || !toDateTime) {
        Swal.fire('Error', 'Invalid time selection. Please check start and end times.', 'error');
        return;
      }

      const fromEpoch = fromDateTime.valueOf();
      const toEpoch = toDateTime.valueOf();

      if (fromEpoch >= toEpoch) {
        Swal.fire('Error', 'Start time must be before end time.', 'error');
        return;
      }

      const durations = Math.floor((toEpoch - fromEpoch) / 1000);
      const shiftEpoch = getEpochFromShift(selectedShift, selectedDate);
      const fromtime = shiftEpoch.fromEpoch;
      const totime = shiftEpoch.toEpoch;

      if (!fromtime || !totime) {
        Swal.fire('Error', 'Unable to determine shift boundaries.', 'error');
        return;
      }

      // Find the selected operator
      const selectedOperator = operatorslist.find(op => op.operatorid === selectedOperatorId);
      if (!selectedOperator) {
        Swal.fire('Error', 'Selected operator not found.', 'error');
        return;
      }

      // Check for overlapping entries
      const response = await telemetrykeydata(
        selectedDeviceId,
        'DEVICE',
        'live_operator',
        fromtime,
        totime
      );

      const existingEntries = response?.live_operator || [];
      const overlapping = [];

      for (const item of existingEntries) {
        if (!item?.value) continue;
        let parsed;
        try {
          parsed = JSON.parse(item.value);
        } catch {
          continue;
        }
        const existingStart = parsed.start_time || item.ts;
        const existingEnd =
          parsed.end_time ||
          (existingStart + (parsed.duration || 0) * 1000);
        const isOverlapping = fromEpoch < existingEnd && existingStart < toEpoch;
        if (isOverlapping) {
          overlapping.push({ item, parsed, existingStart, existingEnd });
        }
      }
      if (overlapping.length > 0) {
        setOpenEditDialog(false);
        const overlapDetails = overlapping.map(overlap => {
          const existingOperator = overlap.parsed.name || 'Unknown';
          const conflictStart = dayjs(overlap.existingStart).format('DD-MM-YYYY HH:mm:ss');
          const conflictEnd = dayjs(overlap.existingEnd).format('DD-MM-YYYY HH:mm:ss');
          return `"<strong>${existingOperator}</strong>" between <strong>${conflictStart}</strong> and <strong>${conflictEnd}</strong>.`;
        }).join('<br>');
        const result1 = await Swal.fire({
          icon: 'error',
          title: 'Error',
          html: `Time overlaps with existing operator ${overlapDetails}`,
          showCancelButton: true,
          confirmButtonText: 'Overwrite',
          cancelButtonText: 'No, Cancel',
          backdrop: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false
        });

        if (!result1.isConfirmed) {
          console.log("User cancelled overwrite.");
          return;
        }
        const result2 = await Swal.fire({
          title: 'Confirm Overwrite',
          text: 'Do you want to overwrite the existing operator allocation with the new changes?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes, Save',
          cancelButtonText: 'No, Cancel',
          backdrop: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false
        });

        if (!result2.isConfirmed) {
          console.log("User cancelled save.");
          return;
        }
        for (const overlap of overlapping) {
          const { parsed, existingStart, existingEnd } = overlap;
          if (fromEpoch > existingStart && toEpoch < existingEnd) {
            const leftDuration = Math.floor((fromEpoch - existingStart) / 1000);
            const rightDuration = Math.floor((existingEnd - toEpoch) / 1000);
            await DowntimeaddDelete('DEVICE', selectedDeviceId, 'live_operator', existingStart, existingEnd);
            const leftKey = {
              ts: existingStart,
              values: {
                live_operator: {
                  ...parsed,
                  start_time: existingStart,
                  end_time: fromEpoch,
                  duration: leftDuration,
                },
              },
            };
            await Downtimeadd1('DEVICE', selectedDeviceId, 'SERVER_SCOPE', leftKey);
            const rightKey = {
              ts: toEpoch,
              values: {
                live_operator: {
                  ...parsed,
                  start_time: toEpoch,
                  end_time: existingEnd,
                  duration: rightDuration,
                },
              },
            };
            await Downtimeadd1('DEVICE', selectedDeviceId, 'SERVER_SCOPE', rightKey);
          }
          else if (fromEpoch <= existingStart && toEpoch > existingStart && toEpoch < existingEnd) {
            await DowntimeaddDelete('DEVICE', selectedDeviceId, 'live_operator', existingStart, existingEnd);

            const newStart = toEpoch;
            const newDuration = Math.floor((existingEnd - newStart) / 1000);
            const updatedKey = {
              ts: newStart,
              values: {
                live_operator: {
                  ...parsed,
                  start_time: newStart,
                  end_time: existingEnd,
                  duration: newDuration,
                },
              },
            };
            await Downtimeadd1('DEVICE', selectedDeviceId, 'SERVER_SCOPE', updatedKey);
          }
          else if (fromEpoch > existingStart && fromEpoch < existingEnd && toEpoch >= existingEnd) {
            await DowntimeaddDelete('DEVICE', selectedDeviceId, 'live_operator', existingStart, existingEnd);
            const newEnd = fromEpoch;
            const newDuration = Math.floor((newEnd - existingStart) / 1000);
            const updatedKey = {
              ts: existingStart,
              values: {
                live_operator: {
                  ...parsed,
                  start_time: existingStart,
                  end_time: newEnd,
                  duration: newDuration,
                },
              },
            };
            await Downtimeadd1('DEVICE', selectedDeviceId, 'SERVER_SCOPE', updatedKey);
          }
          else if (fromEpoch <= existingStart && toEpoch >= existingEnd) {
            await DowntimeaddDelete('DEVICE', selectedDeviceId, 'live_operator', existingStart, existingEnd);
          }
        }
        try {
          const now = Date.now();
          const key = {
            ts: fromEpoch || now,
            values: {
              live_operator: {
                name: selectedOperator.operatorname,
                code: selectedOperatorId,
                start_time: fromEpoch,
                end_time: toEpoch,
                duration: durations
              }
            }
          };

          await Downtimeadd1('DEVICE', selectedDeviceId, 'SERVER_SCOPE', key);
          setDeviceThresholds(prev => ({
            ...prev,
            [selectedDeviceId.id || selectedDeviceId]: selectedOperator.operatorname,
          }));

          Swal.fire({
            title: 'Success',
            text: 'Operator assigned successfully.',
            icon: 'success',
            backdrop: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false
          });
          setTimeout(() => {
            handleSubmit();
          }, 2000);
          return;
        } catch (error) {
          console.error('Error saving operator:', error);
          Swal.fire('Error', 'Failed to assign operator.', 'error');
          return;
        }
      }

      // ✅ Proceed to save if no overlap
      const now = Date.now();
      const key = {
        // ts: fromEpoch > now ? fromEpoch : now,
        ts: fromEpoch || now,
        values: {
          live_operator: {
            name: selectedOperator.operatorname,
            code: selectedOperatorId,
            start_time: fromEpoch,
            end_time: toEpoch,
            duration: durations
          }
        }
      };

      await Downtimeadd1('DEVICE', selectedDeviceId, 'SERVER_SCOPE', key);

      setDeviceThresholds(prev => ({
        ...prev,
        [selectedDeviceId.id || selectedDeviceId]: selectedOperator.operatorname
      }));

      Swal.fire('Success', 'Operator assigned successfully.', 'success');
      setTimeout(() => {
        handleSubmit();
      }, 2000);
    } catch (err) {
      console.error('Update error:', err);
      Swal.fire('Error', 'Failed to assign operator.', 'error');
    } finally {
      setSavingStates(prev => ({ ...prev, operator: false }));
      setOpenEditDialog(false);
    }
  };

  const getAllShiftBounds = (shifts) => {
    if (!shifts || shifts.length === 0) return null;

    const sorted = [...shifts].sort((a, b) => a.shift_no - b.shift_no);

    return {
      start_time: sorted[0].start_time,                 // First shift start
      end_time: sorted[sorted.length - 1].end_time,     // Last shift end
    };
  };


  // HMS / mm:ss / number → seconds. Used by the cycle-mismatch check.
  const parseHmsToSec = (s) => {
    if (s == null) return 0;
    if (typeof s === 'number') return s;
    const m = String(s).match(/^(\d{1,3}):(\d{1,2}):(\d{1,2})$/);
    if (m) return Number(m[1]) * 3600 + Number(m[2]) * 60 + Number(m[3]);
    const m2 = String(s).match(/^(\d{1,3}):(\d{1,2})$/);
    if (m2) return Number(m2[1]) * 60 + Number(m2[2]);
    return Number(s) || 0;
  };
  const fmtMinSec = (sec) => {
    if (!sec || isNaN(sec)) return '-';
    const m = Math.floor(sec / 60);
    const s = Math.round(sec % 60);
    return m > 0 ? `${m}m ${s}s` : `${s}s`;
  };

  // Match by MACHINING TIME ONLY — program-specific, operator-independent.
  const findSuggestedComponent = (observedMachiningMin) => {
    if (!componentslist?.length || !observedMachiningMin || observedMachiningMin <= 0) return null;
    let best = null;
    let bestMachMin = 0;
    let bestDiff = Infinity;
    for (const c of componentslist) {
      const machSec = parseHmsToSec(c.cycle_time);
      if (!machSec) continue;
      const machMin = machSec / 60;
      const diff = Math.abs(machMin - observedMachiningMin);
      if (diff < bestDiff) {
        bestDiff = diff;
        best = c;
        bestMachMin = machMin;
      }
    }
    if (!best) return null;
    const variance = Math.abs(bestMachMin - observedMachiningMin) / observedMachiningMin;
    if (variance > 0.20) return null;
    return {
      component: best,
      machining_min: Math.round(bestMachMin * 10) / 10,
      variance_pct: Math.round(variance * 100),
    };
  };

  const assignSuggestedFromPanel = async (deviceId, deviceName, component) => {
    const confirm = await Swal.fire({
      title: `Assign to ${deviceName}?`,
      html: `<div style="text-align:left;font-size:14px">
        Set <b>${deviceName}</b>'s live component to <b>${component.component_name}</b>?<br/><br/>
        <span style="color:#6b7280;font-size:12px">This updates the live_component attribute so the screens reflect what's actually running on the machine.</span>
      </div>`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, Assign',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#ec6e17',
      cancelButtonColor: '#6b7280',
      reverseButtons: true,
    });
    if (!confirm.isConfirmed) return;
    try {
      const isGplast = cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID;
      const key2 = {
        component_name: component.component_name,
        component_id: component.component_number,
        cycle_time: component.cycle_time,
        handling_time: component.handling_time,
        setup_time: component.setupTime,
        component_start_time: Date.now(),
        ...(isGplast && {
          item_code: component.item_code,
          process_name: component.process_name,
        }),
      };
      const key = {
        live_component: JSON.stringify(key2),
        lastUpdateTs: Date.now(),
      };
      await Downtimeadd1('DEVICE', deviceId, 'SERVER_SCOPE', key);
      Swal.fire({
        title: 'Assigned',
        text: `${component.component_name} is now the live component for ${deviceName}.`,
        icon: 'success',
        timer: 2000,
        showConfirmButton: false,
      });
      setTimeout(() => openMismatchPanel(), 800);
    } catch (e) {
      console.error('assign suggested failed', e);
      Swal.fire('Error', 'Failed to assign component.', 'error');
    }
  };

  // Bulk auto-assign across all customer machines. Fetches the live mismatch
  // panel data (which already has per-machine observed machining, current
  // status, parts produced, and skip reasons) and builds a preview where the
  // supervisor reviews per-row before applying.
  const handleBulkAutoAssign = async () => {
    setBulkPreviewOpen(true);
    setBulkPreviewLoading(true);
    setBulkPreviewRows([]);
    setBulkSelected(new Set());
    try {
      const base = (window._env_?.SERVER_URL2 || '').replace(/\/$/, '');
      const cid = cleanCustomerId(customerId);
      const resp = await fetch(
        `${base}/api/operator-assignment/live-cycle-mismatches?customer_id=${encodeURIComponent(cid)}`,
      );
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      const j = await resp.json();
      const flagged = Array.isArray(j?.machines) ? j.machines : [];
      const skipped = Array.isArray(j?.skipped_non_production) ? j.skipped_non_production : [];

      const rows = [];
      // 1. Flagged machines — try to find a better-matching component
      for (const m of flagged) {
        const sug = findSuggestedComponent(m.observed_machining_min);
        const sameAsCurrent = sug && sug.component.component_name === m.component_name;
        rows.push({
          device_id: m.device_id,
          device_name: m.device_name,
          status: m.current_status,
          parts: `${m.parts_produced}/${m.target_parts ?? '?'}`,
          current_component: m.component_name || '-',
          observed_machining_min: m.observed_machining_min,
          suggested: sug,
          action: sug
            ? (sameAsCurrent ? 'no_change' : 'reassign')
            : 'no_match',
          skip_reason: null,
        });
      }
      // 2. Skipped machines — show as informational, not selectable
      for (const s of skipped) {
        rows.push({
          device_id: s.device_id,
          device_name: s.device_name,
          status: s.current_status,
          parts: `${s.parts_produced}/${s.target_parts ?? '?'}`,
          current_component: s.component_name || '-',
          observed_machining_min: null,
          suggested: null,
          action: 'skip',
          skip_reason: s.reason,
        });
      }
      rows.sort((a, b) => (a.device_name || '').localeCompare(b.device_name || ''));
      setBulkPreviewRows(rows);
      // Pre-select all "reassign" rows (the actionable ones)
      const presel = new Set();
      rows.forEach((r) => { if (r.action === 'reassign') presel.add(r.device_id); });
      setBulkSelected(presel);
    } catch (e) {
      console.warn('bulk preview fetch failed', e);
      Swal.fire('Error', 'Failed to load bulk auto-assign preview.', 'error');
      setBulkPreviewOpen(false);
    } finally {
      setBulkPreviewLoading(false);
    }
  };

  const handleBulkApply = async () => {
    const toApply = bulkPreviewRows.filter(
      (r) => r.action === 'reassign' && r.suggested && bulkSelected.has(r.device_id),
    );
    if (toApply.length === 0) {
      Swal.fire('Nothing selected', 'Select at least one machine to assign.', 'info');
      return;
    }
    const confirm = await Swal.fire({
      title: `Assign ${toApply.length} component${toApply.length === 1 ? '' : 's'}?`,
      html: `<div style="text-align:left;font-size:13px">
        This will set the live component for ${toApply.length} machine${toApply.length === 1 ? '' : 's'} based on observed machining time.<br/><br/>
        <span style="color:#6b7280;font-size:12px">Each machine will get the master component whose declared machining matches its observed cycle.</span>
      </div>`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: `Yes, Assign ${toApply.length}`,
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#10b981',
      cancelButtonColor: '#6b7280',
      reverseButtons: true,
    });
    if (!confirm.isConfirmed) return;

    setBulkApplying(true);
    const isGplast = cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID;
    let succeeded = 0;
    const failed = [];
    for (const r of toApply) {
      try {
        const c = r.suggested.component;
        const key2 = {
          component_name: c.component_name,
          component_id: c.component_number,
          cycle_time: c.cycle_time,
          handling_time: c.handling_time,
          setup_time: c.setupTime,
          component_start_time: Date.now(),
          ...(isGplast && {
            item_code: c.item_code,
            process_name: c.process_name,
          }),
        };
        await Downtimeadd1('DEVICE', r.device_id, 'SERVER_SCOPE', {
          live_component: JSON.stringify(key2),
          lastUpdateTs: Date.now(),
        });
        succeeded += 1;
      } catch (e) {
        failed.push(r.device_name);
      }
    }
    setBulkApplying(false);
    setBulkPreviewOpen(false);
    Swal.fire({
      title: failed.length === 0 ? 'All assigned' : 'Partially complete',
      html: `<div style="font-size:13px;text-align:left">
        Assigned: <b style="color:#047857">${succeeded}</b><br/>
        ${failed.length > 0 ? `Failed: <b style="color:#b91c1c">${failed.length}</b> (${failed.join(', ')})` : ''}
      </div>`,
      icon: failed.length === 0 ? 'success' : 'warning',
    });
  };

  // Smart dispatcher for the page-level button: single-machine if a specific
  // machine is selected, bulk preview otherwise.
  const handlePageAutoAssign = () => {
    const isSpecific = selectedDevice && selectedDevice !== 'all';
    if (isSpecific) {
      // Use the page-level dropdown selection (selectedDevice + selectedDevicename)
      // rather than the dialog's selectedDeviceId, since the dialog isn't open.
      singleAutoAssignByDevice(selectedDevice, selectedDevicename);
    } else {
      handleBulkAutoAssign();
    }
  };

  // Core single-machine auto-assign logic — accepts deviceId + deviceName
  // explicitly so it can be triggered from both the dialog and the page header.
  const singleAutoAssignByDevice = async (deviceId, deviceName) => {
    if (!deviceId) {
      Swal.fire('No machine selected', 'Select a machine from the dropdown first.', 'info');
      return;
    }
    setAutoSuggestLoading(true);
    setAutoSuggestStatus(null);
    try {
      const base = (window._env_?.SERVER_URL2 || '').replace(/\/$/, '');
      const resp = await fetch(
        `${base}/api/operator-assignment/observed-cycle?device_id=${encodeURIComponent(deviceId)}`,
      );
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      const j = await resp.json();
      if (j?.non_production_reason) {
        Swal.fire({
          title: 'Not in production',
          text: `${deviceName || 'Machine'} is not in active production: ${j.non_production_reason}. Auto-assign skipped.`,
          icon: 'info',
        });
        return;
      }
      const observedMach = j?.observed_machining_min;
      if (!observedMach || observedMach <= 0 || (j?.samples ?? 0) < 5) {
        Swal.fire({
          title: 'Not enough data',
          text: `Not enough machining data this shift (${j?.samples ?? 0} samples, ${j?.parts_produced ?? 0} parts produced). Try again after a few more parts.`,
          icon: 'info',
        });
        return;
      }
      const sug = findSuggestedComponent(observedMach);
      if (!sug) {
        Swal.fire({
          title: 'No match in master',
          text: `Machine's machining time is ~${observedMach}m this shift (${j?.parts_produced ?? 0} parts produced), but no component in master matches (within 20%).`,
          icon: 'warning',
        });
        return;
      }
      const mName = deviceName || 'this machine';
      const confirm = await Swal.fire({
        title: 'Auto-Assign Best Match?',
        html: `<div style="text-align:left;font-size:14px;line-height:1.5">
          <div style="background:#ecfdf5;border:1px solid #a7f3d0;padding:10px 12px;border-radius:6px;margin-bottom:12px;color:#065f46">
            Based on this shift's observed machining time of <b>${observedMach} min</b>, the best match is:
          </div>
          <table style="width:100%;border-collapse:collapse;margin:8px 0">
            <tr><td style="padding:4px 0;color:#6b7280">Component</td><td style="text-align:right"><b>${sug.component.component_name}</b></td></tr>
            <tr><td style="padding:4px 0;color:#6b7280">Declared machining</td><td style="text-align:right"><b>${sug.machining_min} min</b></td></tr>
            <tr><td style="padding:4px 0;color:#6b7280">Match quality</td><td style="text-align:right"><b style="color:#047857">${sug.variance_pct === 0 ? 'exact match' : `${sug.variance_pct}% off`}</b></td></tr>
          </table>
          <div style="font-size:12px;color:#6b7280;margin-top:8px">
            Assigning will set <b>${mName}</b>'s live component to <b>${sug.component.component_name}</b>.
          </div>
        </div>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, Assign Now',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#10b981',
        cancelButtonColor: '#6b7280',
        reverseButtons: true,
        width: 560,
      });
      if (!confirm.isConfirmed) return;

      const isGplast = cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID;
      const c = sug.component;
      const key2 = {
        component_name: c.component_name,
        component_id: c.component_number,
        cycle_time: c.cycle_time,
        handling_time: c.handling_time,
        setup_time: c.setupTime,
        component_start_time: Date.now(),
        ...(isGplast && { item_code: c.item_code, process_name: c.process_name }),
      };
      await Downtimeadd1('DEVICE', deviceId, 'SERVER_SCOPE', {
        live_component: JSON.stringify(key2),
        lastUpdateTs: Date.now(),
      });
      Swal.fire({
        title: 'Assigned',
        text: `${c.component_name} is now the live component for ${mName}.`,
        icon: 'success',
        timer: 2200,
        showConfirmButton: false,
      });
    } catch (e) {
      console.warn('page auto-assign failed', e);
      Swal.fire('Error', 'Auto-assign failed. Check connection and try again.', 'error');
    } finally {
      setAutoSuggestLoading(false);
    }
  };

  // Auto-Assign: one-click action — ask backend what cycle this machine is
  // actually running this shift, find the closest component in master by
  // machining time, then confirm and assign the live_component directly.
  // Bypasses the multi-day schedule form (use Save below for full schedule).
  const handleAutoSuggest = async () => {
    if (!selectedDeviceId) {
      Swal.fire('No machine selected', 'Select a machine first.', 'info');
      return;
    }
    setAutoSuggestLoading(true);
    setAutoSuggestStatus(null);
    try {
      const base = (window._env_?.SERVER_URL2 || '').replace(/\/$/, '');
      const resp = await fetch(
        `${base}/api/operator-assignment/observed-cycle?device_id=${encodeURIComponent(selectedDeviceId)}`,
      );
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      const j = await resp.json();
      if (j?.non_production_reason) {
        setAutoSuggestStatus({
          ok: false,
          message: `Machine is not in active production: ${j.non_production_reason}. Auto-assign skipped — observed cycle wouldn't reflect real production.`,
        });
        return;
      }
      const observedMach = j?.observed_machining_min;
      if (!observedMach || observedMach <= 0 || (j?.samples ?? 0) < 5) {
        setAutoSuggestStatus({
          ok: false,
          message: `Not enough machining data this shift (${j?.samples ?? 0} samples, ${j?.parts_produced ?? 0} parts produced). Try again after a few more parts.`,
        });
        return;
      }
      const sug = findSuggestedComponent(observedMach);
      if (!sug) {
        setAutoSuggestStatus({
          ok: false,
          message: `Machine's machining time is ~${observedMach}m this shift (${j?.parts_produced ?? 0} parts produced), but no component in master matches (within 20%). Update master or add a new component.`,
        });
        return;
      }

      const machineName = selectedDevicename || 'this machine';
      const confirm = await Swal.fire({
        title: 'Auto-Assign Best Match?',
        html: `<div style="text-align:left;font-size:14px;line-height:1.5">
          <div style="background:#ecfdf5;border:1px solid #a7f3d0;padding:10px 12px;border-radius:6px;margin-bottom:12px;color:#065f46">
            Based on this shift's observed machining time of <b>${observedMach} min</b>, the best match is:
          </div>
          <table style="width:100%;border-collapse:collapse;margin:8px 0">
            <tr><td style="padding:4px 0;color:#6b7280">Component</td><td style="text-align:right"><b>${sug.component.component_name}</b></td></tr>
            <tr><td style="padding:4px 0;color:#6b7280">Declared machining</td><td style="text-align:right"><b>${sug.machining_min} min</b></td></tr>
            <tr><td style="padding:4px 0;color:#6b7280">Match quality</td><td style="text-align:right"><b style="color:#047857">${sug.variance_pct === 0 ? 'exact match' : `${sug.variance_pct}% off`}</b></td></tr>
          </table>
          <div style="font-size:12px;color:#6b7280;margin-top:8px">
            Assigning will set <b>${machineName}</b>'s live component to <b>${sug.component.component_name}</b>. To schedule the component across future shifts, use the Save button below instead.
          </div>
        </div>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, Assign Now',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#10b981',
        cancelButtonColor: '#6b7280',
        reverseButtons: true,
        width: 560,
      });
      if (!confirm.isConfirmed) {
        setAutoSuggestStatus({ ok: true, message: 'Cancelled.' });
        return;
      }

      const isGplast = cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID;
      const key2 = {
        component_name: sug.component.component_name,
        component_id: sug.component.component_number,
        cycle_time: sug.component.cycle_time,
        handling_time: sug.component.handling_time,
        setup_time: sug.component.setupTime,
        component_start_time: Date.now(),
        ...(isGplast && {
          item_code: sug.component.item_code,
          process_name: sug.component.process_name,
        }),
      };
      const key = {
        live_component: JSON.stringify(key2),
        lastUpdateTs: Date.now(),
      };
      await Downtimeadd1('DEVICE', selectedDeviceId, 'SERVER_SCOPE', key);
      setselectedcomponent(sug.component.component_name);
      setSelectedComponentId(sug.component.id || '');
      setOpenEditDialog1(false);
      Swal.fire({
        title: 'Assigned',
        text: `${sug.component.component_name} is now the live component for ${machineName}.`,
        icon: 'success',
        timer: 2200,
        showConfirmButton: false,
      });
    } catch (e) {
      console.warn('auto-assign failed', e);
      setAutoSuggestStatus({ ok: false, message: 'Auto-assign failed. Check connection and try again.' });
    } finally {
      setAutoSuggestLoading(false);
    }
  };

  const openMismatchPanel = async () => {
    setMismatchOpen(true);
    setMismatchLoading(true);
    try {
      const base = (window._env_?.SERVER_URL2 || '').replace(/\/$/, '');
      const cid = cleanCustomerId(customerId);
      const [liveResp, logResp] = await Promise.all([
        fetch(`${base}/api/operator-assignment/live-cycle-mismatches?customer_id=${encodeURIComponent(cid)}`),
        fetch(`${base}/api/operator-assignment/cycle-mismatch-log-all?customer_id=${encodeURIComponent(cid)}&limit=50`),
      ]);
      if (liveResp.ok) {
        const j = await liveResp.json();
        setLiveMismatches(Array.isArray(j?.machines) ? j.machines : []);
        setMismatchShiftStartIst(j?.shift_start_ist || null);
        setMismatchSkipped(Array.isArray(j?.skipped_non_production) ? j.skipped_non_production : []);
      } else {
        setLiveMismatches([]);
        setMismatchShiftStartIst(null);
        setMismatchSkipped([]);
      }
      if (logResp.ok) {
        const j = await logResp.json();
        setMismatchEvents(Array.isArray(j?.events) ? j.events : []);
      } else {
        setMismatchEvents([]);
      }
    } catch (e) {
      console.warn('mismatch fetch failed', e);
      setLiveMismatches([]);
      setMismatchEvents([]);
    } finally {
      setMismatchLoading(false);
    }
  };

  const handleSaveThreshold1 = async () => {

    if (savingComponent) {
      return;
    }
    if (selectedDate && !selectedDate.isValid()) {
      Swal.fire('Error', 'Invalid date format. Please select a valid date.', 'error');
      return;
    }
    // if (selectedDate && endDate && endDate.isBefore(selectedDate, 'day')) {
    //   setSelectedDate(endDate);
    // }

    if (startTime && !startTime.isValid()) {
      Swal.fire('Error', 'Invalid start time format. Please select a valid time.', 'error');
      return;
    }

    if (endTime && !endTime.isValid()) {
      Swal.fire('Error', 'Invalid end time format. Please select a valid time.', 'error');
      return;
    }

    if (startTime && endTime && startTime.isSame(endTime, 'second')) {
      Swal.fire('Error', 'Start Time and End Time cannot be the same!', 'error');
      return;
    }

    const hasErrors = timeErrors.startTime || timeErrors.endTime;
    if (hasErrors) {
      Swal.fire('Error', 'Please fix the time validation errors before saving.', 'error');
      return;
    }

    if (!selectedDeviceId || !selectedShift || !selectedDate || !endDate || !selectedComponentId) {
      Swal.fire('Error', 'Please fill all required fields.', 'error');
      return;
    }


    const selectedShiftData = selectedShift !== 'ALL'
      ? shifts.find(shift => shift.shift_no == selectedShift)
      : null;

    if (selectedShift !== 'ALL' && !selectedShiftData) {
      Swal.fire('Error', 'Selected shift not found.', 'error');
      return;
    }


    const component = componentslist.find(comp => comp.id === selectedComponentId);
    if (!component) {
      Swal.fire('Error', 'Selected component not found.', 'error');
      return;
    }

    if (!Array.isArray(shifts) || shifts.length === 0) {
      Swal.fire('Error', 'Shift data not loaded yet. Please try again.', 'error');
      return;
    }


    // Set saving state
    setSavingComponent(true);

    try {
      // -------------------- COMPONENT DATA --------------------
      const componentName = component.component_name;
      const componentNumber = component.component_number || null;
      const itemCode = component.item_code || null;
      const processName = component.process_name || null;
      const cycleTime = component.cycle_time || null;
      const handlingTime = component.handling_time || null;
      const setupTime = component.setupTime || null;
      const factorValue = component.factorval || null;
      const factors = component.factor || null;

      // -------------------- CYCLE-TIME MISMATCH GUARDRAIL --------------------
      // Warn the supervisor if the machine's recently observed cycle time is
      // >20% off the expected cycle for the component being assigned. Common
      // cause = wrong program loaded. Backend silently no-ops with
      // insufficient_data when there aren't enough recent samples.
      try {
        const base = (window._env_?.SERVER_URL2 || '').replace(/\/$/, '');
        // Master `cycle_time` is machining-only. True per-part cycle = machining + handling.
        const expectedSec = parseHmsToSec(cycleTime) + parseHmsToSec(handlingTime);
        if (base && selectedDeviceId && expectedSec > 0) {
          const resp = await fetch(`${base}/api/operator-assignment/check-cycle-match`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              device_id: selectedDeviceId,
              expected_cycle_sec: expectedSec,
              component_id: componentNumber,
              component_name: componentName,
            }),
          });
          if (resp.ok) {
            const j = await resp.json();
            if (j && j.matches === false && j.reason === 'mismatch') {
              const machineName = selectedDevicename || 'this machine';
              const html =
                `<div style="text-align:left;font-size:14px;line-height:1.5">
                  <div style="background:#fff3cd;border:1px solid #ffe69c;padding:10px 12px;border-radius:6px;margin-bottom:12px;color:#664d03">
                    <b>${machineName}</b> is currently producing parts at a different pace than this component expects.
                  </div>
                  <table style="width:100%;border-collapse:collapse;margin:8px 0">
                    <tr><td style="padding:4px 0;color:#6b7280">Expected cycle (for <b>${componentName || ''}</b>)</td><td style="text-align:right"><b>${fmtMinSec(j.expected_cycle_sec)}</b></td></tr>
                    <tr><td style="padding:4px 0;color:#6b7280">Actual median (last ${j.lookback_hours}h, ${j.samples} parts)</td><td style="text-align:right"><b>${fmtMinSec(j.actual_median_sec)}</b></td></tr>
                    <tr><td style="padding:4px 0;color:#6b7280">Deviation</td><td style="text-align:right"><b style="color:#dc2626">${j.variance_pct}% off</b></td></tr>
                  </table>
                  <div style="font-size:12px;color:#6b7280;margin-top:8px">
                    Likely causes: wrong program loaded, different component still running, or component master cycle time needs updating.
                  </div>
                </div>`;
              const confirm = await Swal.fire({
                title: 'Cycle time mismatch',
                html,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Continue Anyway',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#ec6e17',
                cancelButtonColor: '#6b7280',
                reverseButtons: true,
                width: 520,
              });
              if (!confirm.isConfirmed) {
                setSavingComponent(false);
                return;
              }
            }
          }
        }
      } catch (mismatchErr) {
        console.warn('cycle-mismatch check skipped:', mismatchErr);
      }

      // -------------------- COMMON TIME VARS --------------------
      const today = dayjs().startOf('day');
      const now = dayjs();

      let currentDate = selectedDate.startOf('day');
      const finalDate = endDate.startOf('day');
      const allOverlaps = [];

      // =========================================================
      // INITIAL SAVE LOOP
      // =========================================================
      while (currentDate.isBefore(finalDate, 'day') || currentDate.isSame(finalDate, 'day')) {
        // -------------------- ALL SHIFTS --------------------
        if (selectedShift === 'ALL') {

          for (const shift of shifts) {

            const shiftStart = dayjs(shift.start_time, ["HH:mm:ss", "HH:mm"]);
            const shiftEnd = dayjs(shift.end_time, ["HH:mm:ss", "HH:mm"]);

            const shiftStartDT = getAdjustedDateTime(shiftStart, currentDate, shift);
            const shiftEndDT = getAdjustedDateTime(shiftEnd, currentDate, shift);
            if (!shiftStartDT || !shiftEndDT) continue;

            let effectiveStartTime;
            let effectiveEndTime;

            if (currentDate.isSame(today, 'day')) {

              if (shiftEndDT.isBefore(now)) continue;

              if (shiftStartDT.isBefore(now) && shiftEndDT.isAfter(now)) {
                effectiveStartTime = now;
                effectiveEndTime = shiftEnd;
              }

              if (shiftStartDT.isAfter(now)) {
                effectiveStartTime = shiftStart;
                effectiveEndTime = shiftEnd;
              }

            } else {
              effectiveStartTime = shiftStart;
              effectiveEndTime = shiftEnd;
            }

            const fromDT = getAdjustedDateTime(effectiveStartTime, currentDate, shift);
            const toDT = getAdjustedDateTime(effectiveEndTime, currentDate, shift);
            if (!fromDT || !toDT) continue;

            const fromEpoch = fromDT.valueOf();
            const toEpoch = toDT.valueOf();
            if (fromEpoch >= toEpoch) continue;

            const duration = Math.floor((toEpoch - fromEpoch) / 1000);
            const { fromEpoch: shiftFrom, toEpoch: shiftTo } =
              getEpochFromShift(shift.shift_no, currentDate);

            const response = await telemetrykeydata(
              selectedDeviceId,
              'DEVICE',
              'live_component',
              shiftFrom,
              shiftTo
            );

            const existingEntries = response?.live_component || [];
            const overlaps = [];

            for (const item of existingEntries) {
              if (!item?.value) continue;
              let parsed;
              try { parsed = JSON.parse(item.value); } catch { continue; }

              const existStart = parsed.start_time || item.ts;
              const existEnd = parsed.end_time || (existStart + (parsed.duration || 0) * 1000);

              if (fromEpoch < existEnd && existStart < toEpoch) {
                overlaps.push({
                  parsed,
                  existingStart: existStart,
                  existingEnd: existEnd, newStart: fromEpoch,
                  newEnd: toEpoch,

                  date: currentDate.format('DD-MM-YYYY')
                });
              }
            }

            if (overlaps.length) {
              allOverlaps.push(...overlaps);
            } else {
              const key = {
                ts: fromEpoch,
                values: {
                  live_component: {
                    name: componentName,
                    code: componentNumber,
                    start_time: fromEpoch,
                    end_time: toEpoch,
                    duration,
                    cycle_time: cycleTime,
                    handling_time: handlingTime,
                    setup_time: setupTime,
                    factorval: factorValue,
                    factor: factors,
                    ...(cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID && {
                      item_code: itemCode,
                      process_name: processName
                    })
                  }
                }
              };
              await Downtimeadd1('DEVICE', selectedDeviceId, 'SERVER_SCOPE', key);
            }
          }
        }

        // -------------------- SINGLE SHIFT --------------------
        else {
          const isToday = currentDate.isSame(today, 'day');
          const currentShift = getCurrentShift(shifts, now);
          const isCurrentShift = currentShift?.shift_no === selectedShift;

          let effectiveStartTime;
          let effectiveEndTime;

          if (isToday) {
            effectiveStartTime = dayjs(startTime, ["HH:mm:ss", "HH:mm"]);
            effectiveEndTime = dayjs(endTime, ["HH:mm:ss", "HH:mm"]);
          } else if (isCurrentShift && selectedDate.isSame(today, 'day')) {
            effectiveStartTime = dayjs(selectedShiftData.start_time, ["HH:mm:ss", "HH:mm"]);
            effectiveEndTime = dayjs(selectedShiftData.end_time, ["HH:mm:ss", "HH:mm"]);
          } else {
            effectiveStartTime = dayjs(startTime, ["HH:mm:ss", "HH:mm"]);
            effectiveEndTime = dayjs(endTime, ["HH:mm:ss", "HH:mm"]);
          }

          const fromDT = getAdjustedDateTime(effectiveStartTime, currentDate, selectedShiftData);
          const toDT = getAdjustedDateTime(effectiveEndTime, currentDate, selectedShiftData);
          if (!fromDT || !toDT) {
            currentDate = currentDate.add(1, 'day');
            continue;
          }

          const fromEpoch = fromDT.valueOf();
          const toEpoch = toDT.valueOf();
          if (fromEpoch < toEpoch) {

            const duration = Math.floor((toEpoch - fromEpoch) / 1000);
            const { fromEpoch: shiftFrom, toEpoch: shiftTo } =
              getEpochFromShift(selectedShift, currentDate);

            const response = await telemetrykeydata(
              selectedDeviceId,
              'DEVICE',
              'live_component',
              shiftFrom,
              shiftTo
            );

            const existingEntries = response?.live_component || [];
            const overlaps = [];

            for (const item of existingEntries) {
              if (!item?.value) continue;
              let parsed;
              try { parsed = JSON.parse(item.value); } catch { continue; }

              const existStart = parsed.start_time || item.ts;
              const existEnd = parsed.end_time || (existStart + (parsed.duration || 0) * 1000);

              if (fromEpoch < existEnd && existStart < toEpoch) {
                overlaps.push({
                  parsed,
                  existingStart: existStart,
                  existingEnd: existEnd,
                  date: currentDate.format('DD-MM-YYYY'),
                  newStart: fromEpoch,
                  newEnd: toEpoch,
                });
              }
            }

            if (overlaps.length) {
              allOverlaps.push(...overlaps);
            } else {
              const key = {
                ts: fromEpoch,
                values: {
                  live_component: {
                    name: componentName,
                    code: componentNumber,
                    start_time: fromEpoch,
                    end_time: toEpoch,
                    duration,
                    cycle_time: cycleTime,
                    handling_time: handlingTime,
                    setup_time: setupTime,
                    factorval: factorValue,
                    factor: factors,
                    ...(cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID && {
                      item_code: itemCode,
                      process_name: processName
                    })
                  }
                }
              };
              await Downtimeadd1('DEVICE', selectedDeviceId, 'SERVER_SCOPE', key);
            }
          }
        }

        currentDate = currentDate.add(1, 'day');
      }

      // =========================================================
      // OVERWRITE FLOW (UNCHANGED LOGIC)
      // =========================================================
      if (allOverlaps.length) {
        setOpenEditDialog1(false);

        const details = allOverlaps.map(o =>
          `"<strong>${o.parsed.name || 'Unknown'}</strong>" (${o.date}) between
       <strong>${dayjs(o.existingStart).format('DD-MM-YYYY HH:mm:ss')}</strong>
       and
       <strong>${dayjs(o.existingEnd).format('DD-MM-YYYY HH:mm:ss')}</strong>`
        ).join('<br>');

        const result = await Swal.fire({
          icon: 'warning',
          title: 'Overlapping Components Detected',
          html: details + '<br><br>Do you want to overwrite them?',
          showCancelButton: true,
          confirmButtonText: 'Yes, Overwrite',
          cancelButtonText: 'No, Cancel',
          width: 700,
          allowOutsideClick: false
        });

        if (!result.isConfirmed) {
          setSavingComponent(false);
          return;
        }

        for (const o of allOverlaps) {
          const {
            parsed,
            existingStart,
            existingEnd,
            newStart,
            newEnd
          } = o;

          // 1️⃣ Delete original
          await DowntimeaddDelete(
            'DEVICE',
            selectedDeviceId,
            'live_component',
            existingStart,
            existingEnd
          );

          // 2️⃣ LEFT PART (existingStart → newStart)
          if (existingStart < newStart) {
            const leftDuration = Math.floor((newStart - existingStart) / 1000);

            if (leftDuration > 0) {
              const leftKey = {
                ts: existingStart,
                values: {
                  live_component: {
                    ...parsed,
                    start_time: existingStart,
                    end_time: newStart,
                    duration: leftDuration,
                  },
                },
              };

              await Downtimeadd1('DEVICE', selectedDeviceId, 'SERVER_SCOPE', leftKey);
            }
          }

          // 3️⃣ RIGHT PART (newEnd → existingEnd)
          if (newEnd < existingEnd) {
            const rightDuration = Math.floor((existingEnd - newEnd) / 1000);

            if (rightDuration > 0) {
              const rightKey = {
                ts: newEnd,
                values: {
                  live_component: {
                    ...parsed,
                    start_time: newEnd,
                    end_time: existingEnd,
                    duration: rightDuration,
                  },
                },
              };

              await Downtimeadd1('DEVICE', selectedDeviceId, 'SERVER_SCOPE', rightKey);
            }
          }
        }


        // 🔁 Re-run same save logic
        currentDate = selectedDate.startOf('day');
        while (currentDate.isBefore(finalDate, 'day') || currentDate.isSame(finalDate, 'day')) {
          let effectiveStartTime, effectiveEndTime;

          const now = dayjs();
          const isToday = currentDate.isSame(today, 'day');
          const currentShift = getCurrentShift(shifts, now);
          const isCurrentShift = currentShift?.shift_no === selectedShift;
          if (selectedShift === 'ALL') {

            const today = dayjs().startOf('day');
            const now = dayjs();

            for (const shift of shifts) {

              let effectiveStartTime;
              let effectiveEndTime;

              const shiftStart = dayjs(shift.start_time, ["HH:mm:ss", "HH:mm"]);
              const shiftEnd = dayjs(shift.end_time, ["HH:mm:ss", "HH:mm"]);

              const shiftStartDT = getAdjustedDateTime(shiftStart, currentDate, shift);
              const shiftEndDT = getAdjustedDateTime(shiftEnd, currentDate, shift);

              if (!shiftStartDT || !shiftEndDT) continue;

              // 🟢 TODAY logic
              if (currentDate.isSame(today, 'day')) {

                // ❌ past shift → skip
                if (shiftEndDT.isBefore(now)) {
                  continue;
                }

                // 🔵 current shift
                if (shiftStartDT.isBefore(now) && shiftEndDT.isAfter(now)) {
                  effectiveStartTime = now;
                  effectiveEndTime = shiftEnd;
                }

                // 🟣 future shift (today)
                if (shiftStartDT.isAfter(now)) {
                  effectiveStartTime = shiftStart;
                  effectiveEndTime = shiftEnd;
                }

              }
              // 🟢 Future dates → full shift
              else {
                effectiveStartTime = shiftStart;
                effectiveEndTime = shiftEnd;
              }
              const fromDateTime = getAdjustedDateTime(effectiveStartTime, currentDate, shift);
              const toDateTime = getAdjustedDateTime(effectiveEndTime, currentDate, shift);

              if (!fromDateTime || !toDateTime) continue;

              const fromEpoch = fromDateTime.valueOf();
              const toEpoch = toDateTime.valueOf();
              if (fromEpoch >= toEpoch) continue;

              const durations = Math.floor((toEpoch - fromEpoch) / 1000);
              const key = {
                ts: fromEpoch || now,
                values: {
                  live_component: {
                    name: componentName,
                    code: componentNumber,
                    start_time: fromEpoch,
                    end_time: toEpoch,
                    duration: durations,
                    cycle_time: cycleTime,
                    handling_time: handlingTime,
                    setup_time: setupTime,
                    factorval: factorValue,
                    factor: factors,
                    ...(cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID && {
                      item_code: itemCode,
                      process_name: processName,
                    }),
                  },
                },
              };
              await Downtimeadd1('DEVICE', selectedDeviceId, 'SERVER_SCOPE', key);
            }
          } else {
            // Single shift re-save logic (same as before)
            if (isToday) {
              effectiveStartTime = dayjs(startTime, ["HH:mm:ss", "HH:mm"]);
              effectiveEndTime = dayjs(endTime, ["HH:mm:ss", "HH:mm"]);
            } else if (isCurrentShift && selectedDate.isSame(today, 'day')) {
              effectiveStartTime = dayjs(selectedShiftData.start_time, ["HH:mm:ss", "HH:mm"]);
              effectiveEndTime = dayjs(selectedShiftData.end_time, ["HH:mm:ss", "HH:mm"]);
            } else {
              effectiveStartTime = dayjs(startTime, ["HH:mm:ss", "HH:mm"]);
              effectiveEndTime = dayjs(endTime, ["HH:mm:ss", "HH:mm"]);
            }

            const fromDateTime = getAdjustedDateTime(effectiveStartTime, currentDate, selectedShiftData);
            const toDateTime = getAdjustedDateTime(effectiveEndTime, currentDate, selectedShiftData);

            if (!fromDateTime || !toDateTime) {
              currentDate = currentDate.add(1, 'day');
              continue;
            }

            const fromEpoch = fromDateTime.valueOf();
            const toEpoch = toDateTime.valueOf();
            const durations = Math.floor((toEpoch - fromEpoch) / 1000);

            const key = {
              ts: fromEpoch || now,
              values: {
                live_component: {
                  name: componentName,
                  code: componentNumber,
                  start_time: fromEpoch,
                  end_time: toEpoch,
                  duration: durations,
                  cycle_time: cycleTime,
                  handling_time: handlingTime,
                  setup_time: setupTime,
                  factorval: factorValue,
                  factor: factors,
                  ...(cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID && {
                    item_code: itemCode,
                    process_name: processName,
                  }),
                },
              },
            };
            await Downtimeadd1('DEVICE', selectedDeviceId, 'SERVER_SCOPE', key);
          }

          currentDate = currentDate.add(1, 'day');
        }
      }

      Swal.fire({
        title: 'Success',
        text: 'Component assigned successfully for all selected dates.',
        icon: 'success',
        allowOutsideClick: false
      });

      setTimeout(() => handleSubmit(), 2000);

    } catch (error) {
      console.error('Error assigning component:', error);
      Swal.fire('Error', 'An error occurred while assigning the component.', 'error');
      setSavingComponent(false);
    }
    finally {
      setSavingComponent(false);
      handleCloseComponentDialog();
    }
  };

  const handleCloseComponentDialog = () => {
    setOpenEditDialog1(false);
    setselectedcomponent('');
    setSelectedComponentId('');
    setSavingComponent(false); // Reset saving state
    setTimeErrors({ startTime: '', endTime: '' }); // Also reset errors
  };
  const getCurrentShift = (allShifts, selectedDate = dayjs()) => {
    const now = dayjs(selectedDate);
    for (let shift of allShifts) {
      const [startH, startM, startS = 0] = shift.start_time.split(":").map(Number);
      const [endH, endM, endS = 0] = shift.end_time.split(":").map(Number);
      let start = dayjs(now).hour(startH).minute(startM).second(startS).millisecond(0);
      let end = dayjs(now).hour(endH).minute(endM).second(endS).millisecond(0);
      if (end.isBefore(start)) {
        if (now.isBefore(end)) {
          start = start.subtract(1, "day");
        } else {
          end = end.add(1, "day");
        }
      }
      if (now.isAfter(start) && now.isBefore(end)) {
        return shift;
      }
    }
    return null;
  };

  const handleSaveThreshold2 = async () => {
    if (
      !startTime || !endTime ||
      !isTimeInShift(startTime, selectedShiftData) ||
      !isTimeInShift(endTime, selectedShiftData)
    ) {
      setOpenEditDialog(false);
      setOpenEditDialog1(false);
      setOpenEditDialog4(false);
      Swal.fire('Error', 'Selected time is outside the shift range!', 'error');
      return;
    }
    try {
      const completedRows = filteredResult.filter(item => item.reasonselected);

      if (completedRows.length === 0) {
        Swal.fire('Warning', 'No reasons selected to save.', 'warning');
        return;
      }

      for (const item of completedRows) {
        const operator = reasonslist.find(op => op.reason === item.reasonselected);
        const code = operator ? operator.code : null;
        const mode = operator ? operator.mode : null;
        const category = operator ? operator.category : null;

        const key = {
          ts: item.start,  // This becomes the top-level "ts" field
          values: {
            live_reason: {
              name: item.reasonselected,
              code: code,
              mode: mode,
              group: item.groupselected || null,
              category: category,
              idle_start: item.start,
              idle_end: item.end,
              idle_duration: item.duration
              // idle_start can be same as item.start or adjusted as needed

            }
          }
        };


        await Downtimeadd1('DEVICE', selectedDeviceId, 'SERVER_SCOPE', key);

        if (item.reasonChanged) {
          const deviceId = selectedDeviceId?.id || selectedDeviceId;
          await updateIdleReason(deviceId, selectedDevicename, key);
        }

        // Optional: Update UI state to reflect change
        setDeviceThresholds(prev => ({
          ...prev,
          [selectedDeviceId.id || selectedDeviceId]: item.reasonselected
        }));
      }

      Swal.fire('Success', 'Reasons assigned successfully.', 'success');

    } catch (err) {
      console.error('Update error:', err);
      Swal.fire('Error', 'Failed to assign reason.', 'error');
    } finally {
      setOpenEditDialog2(false);
    }
  };

  const handleAssignModeChange = (e) => {
    setSelectedassignmode(e.target.value);
  };
  const handleFormChange2 = (event) => {
    const { name, value } = event.target;
    setselectedcomponent(value);
  };

  const isShiftOvernight = (shift) => {
    if (!shift) return false;
    if (parseInt(shift.start_day) !== parseInt(shift.end_day)) return true;
    const [startHour, startMin] = shift.start_time.split(':').map(Number);
    const [endHour, endMin] = shift.end_time.split(':').map(Number);
    if (endHour < startHour || (endHour === startHour && endMin < startMin)) {
      return true;
    }
    return false;
  };

  const filteredComponents = useMemo(() => {
    if (!selectedProcess) return components;
    console.log(components, 'components')
    return components.filter(
      comp =>
        comp.process_name &&
        comp.process_name.toLowerCase() === selectedProcess.toLowerCase()
    );
  }, [components, selectedProcess]);

  const getShiftBoundaries = (shift, baseDate) => {
    if (!shift) return { shiftStart: null, shiftEnd: null };
    const startDay = parseInt(shift.start_day);
    const endDay = parseInt(shift.end_day);
    const isOvernight = isShiftOvernight(shift);
    const [startHour, startMinute, startSecond] = shift.start_time.split(':').map(Number);
    const [endHour, endMinute, endSecond] = shift.end_time.split(':').map(Number);
    let shiftStart = dayjs(baseDate)
      .add(startDay - 1, 'day')
      .set('hour', startHour)
      .set('minute', startMinute)
      .set('second', startSecond || 0)
      .set('millisecond', 0);;
    let shiftEnd = dayjs(baseDate)
      .add(endDay - 1, 'day')
      .set('hour', endHour)
      .set('minute', endMinute)
      .set('second', endSecond || 0)
      .set('millisecond', 0);
    return { shiftStart, shiftEnd };
  };

  const getAdjustedDateTime = (timeValue, selectedDate, shift) => {
    if (!timeValue || !shift) return null;
    const startDay = parseInt(shift.start_day);
    const endDay = parseInt(shift.end_day);
    const isOvernight = isShiftOvernight(shift);
    let datetime = dayjs(selectedDate)
      .set('hour', timeValue.hour())
      .set('minute', timeValue.minute())
      .set('second', timeValue.second())
      .set('millisecond', 0);
    const { shiftStart, shiftEnd } = getShiftBoundaries(shift, selectedDate);
    if (startDay > 1 && endDay > 1) {
      datetime = datetime.add(startDay - 1, 'day');
    }
    else if (isOvernight && startDay === 1 && endDay === 2) {
      if (timeValue.hour() < 12) {
        datetime = datetime.add(1, 'day');
      }
    }
    else if (isOvernight) {
      const startHour = parseInt(shift.start_time.split(':')[0]);
      const endHour = parseInt(shift.end_time.split(':')[0]);
      if (startHour >= 18 && timeValue.hour() < 12) {
        datetime = datetime.add(1, 'day');
      }
    }
    return datetime;
  };

  const selectedShiftData = shifts.find(shift => shift.shift_no === selectedShift);

  const dialogWidth = useMemo(() => {
    return cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID ? '1000px' : '800px';
  }, [customerId]);

  const isEndDateBeforeStart =
    selectedDate &&
    endDate &&
    selectedDate.isValid() &&
    endDate.isValid() &&
    endDate.isBefore(selectedDate, 'day');

  const isOvernightShift = (shift) => {
    if (!shift) return false;
    const start = dayjs(shift.start_time, 'HH:mm:ss');
    const end = dayjs(shift.end_time, 'HH:mm:ss');
    return start.isAfter(end);
  };


  const shouldDisableTime = (value, view) => {
    if (!selectedShiftData) return false;

    const time = dayjs(value);
    const start = dayjs(selectedShiftData.start_time, 'HH:mm:ss');
    const end = dayjs(selectedShiftData.end_time, 'HH:mm:ss');

    if (!isOvernightShift(selectedShiftData)) {
      return !time.isBetween(start, end, null, '[]');
    }

    return !(
      time.isSame(start) ||
      time.isAfter(start) ||
      time.isBefore(end) ||
      time.isSame(end)
    );
  };




  return (
    <div className="pages">
      {/* Page-level tabs consolidating Allocation view + Smart Operator Assignment */}
      <Tabs
        value={activeTab}
        onChange={(_, v) => setActiveTab(v)}
        sx={{
          borderBottom: '1px solid var(--y-border, #e5e7eb)',
          background: 'var(--y-bg, #fff)',
          '& .MuiTab-root': { textTransform: 'none', fontWeight: 600, fontSize: 13 },
          '& .Mui-selected': { color: '#f97316 !important' },
          '& .MuiTabs-indicator': { backgroundColor: '#f97316' },
        }}
      >
        <Tab value="allocation" label="📋 Allocation View" />
        <Tab value="assignment" label="🎯 Operator Assignment" />
      </Tabs>

      {activeTab === 'assignment' && (
        <div style={{ padding: '8px 0' }}>
          <SmartOperator />
        </div>
      )}

      {activeTab === 'allocation' && (<>
      <div className="pagecontents">
        <br></br>
        {/* <div className="left-labels" style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h5>Machine Name : {selectedDevicename}</h5>
        </div> */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <div style={{ display: 'flex', gap: '16px', marginBottom: '16px', alignItems: 'center' }}>
            <DateTimePicker
              label="Start Date & Time *"
              value={startDateTime}
              onChange={(newValue) => setStartDateTime(newValue)}
              ampm={false}
              required={true}
              format="DD-MM-YYYY HH:mm:ss"
              views={['year', 'month', 'day', 'hours', 'minutes', 'seconds']}
              inputFormat="DD-MM-YYYY HH:mm:ss"
              renderInput={(params) => <TextField {...params} required />}
              sx={{
                width: 250,
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: 'black',
                  },
                  '&:hover fieldset': {
                    borderColor: 'black',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: 'orange',
                  },
                  '& .MuiOutlinedInput-input': {
                    color: 'black',
                  },
                  '&.Mui-focused .MuiOutlinedInput-input': {
                    caretColor: 'orange',
                  },
                  '&::placeholder': {
                    color: 'black',
                    opacity: 1,
                  },
                },
              }}
            />
            <DateTimePicker
              label="End Date & Time *"
              value={endDateTime}
              required={true}
              onChange={(newValue) => setEndDateTime(newValue)}
              ampm={false}
              format="DD-MM-YYYY HH:mm:ss"
              views={['year', 'month', 'day', 'hours', 'minutes', 'seconds']}
              inputFormat="DD-MM-YYYY HH:mm:ss"
              renderInput={(params) => <TextField {...params} required />}
              sx={{
                width: 250,
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: 'black',
                  },
                  '&:hover fieldset': {
                    borderColor: 'black',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: 'orange',
                  },
                  '& .MuiOutlinedInput-input': {
                    color: 'black',
                  },
                  '&.Mui-focused .MuiOutlinedInput-input': {
                    caretColor: 'orange',
                  },
                  '&::placeholder': {
                    color: 'black',
                    opacity: 1,
                  },
                },
              }}
            />
            <CustomDaySelect
              name="Assigns"
              value={selectedassignmode}
              onChange={(e) => setSelectedassignmode(e.target.value)}
              label="Select Assigns"
              required={true}
              options={Assignmodes}
              sx={{
                width: 250,
              }}
            />
            {(selectedassignmode === 'Operator' || selectedassignmode === 'Component' || selectedassignmode === 'Reason') && (

              <CustomDaySelect
                name="device"
                value={selectedDevice}
                onChange={(e) => {
                  setSelectedDevice(e.target.value);
                  // Find the selected device's name from deviceOptions
                  const selected = deviceOptions.find(opt => opt.value === e.target.value);
                  setSelectedDevicename(selected ? selected.label : '');
                }}
                label="Select Machine"
                required={true}
                options={deviceOptions}
                sx={{
                  width: 250,
                }}
              />
            )}

            <Button
              variant="contained"
              color="warning"
              className="filter_btn btn_orange"
              onClick={handleSubmit}
            >
              Submit
            </Button>

            {selectedassignmode === 'Operator' && (
              <>
                <Button
                  variant="contained"
                  color="secondary"
                  className="filter_btn btn_blue"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenEditDialog(selectedDevicename, selectedDevice);
                  }}
                >
                  Quick Assign
                </Button>
                <Button
                  variant="contained"
                  onClick={(e) => {
                    e.stopPropagation();
                    setActiveTab('assignment');
                  }}
                  sx={{
                    marginLeft: '8px',
                    backgroundColor: '#7c3aed',
                    color: '#fff',
                    textTransform: 'none',
                    fontWeight: 600,
                    ':hover': { backgroundColor: '#6d28d9' },
                  }}
                >
                  🎯 Open Smart Operator →
                </Button>
              </>
            )}

            {selectedassignmode === 'Component' && (
              <>
                <Button
                  variant="contained"
                  color="secondary"
                  className="filter_btn btn_green"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenEditDialog1(selectedDevicename, selectedDevice);
                  }}
                >
                  Assign Component
                </Button>
                <Button
                  variant="contained"
                  onClick={handlePageAutoAssign}
                  disabled={autoSuggestLoading || bulkPreviewLoading}
                  sx={{
                    marginLeft: '8px',
                    backgroundColor: '#10b981',
                    color: '#fff',
                    textTransform: 'none',
                    fontWeight: 600,
                    ':hover': { backgroundColor: '#059669' },
                  }}
                >
                  {bulkPreviewLoading || autoSuggestLoading
                    ? 'Checking…'
                    : (selectedDevice && selectedDevice !== 'all'
                        ? '🎯 Auto-Assign'
                        : '🎯 Auto-Assign All')}
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  startIcon={<ReportProblemIcon style={{ color: '#dc2626' }} />}
                  onClick={openMismatchPanel}
                  sx={{
                    marginLeft: '8px',
                    borderColor: '#fecaca',
                    color: '#b91c1c',
                    textTransform: 'none',
                    fontSize: 12,
                    ':hover': { borderColor: '#fca5a5', backgroundColor: '#fef2f2' },
                  }}
                >
                  Recent Mismatches
                </Button>
              </>
            )}
            {selectedassignmode === 'Reason' && (
              <Button
                variant="contained"
                color="secondary"
                className="filter_btn btn_green"
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenEditDialog2(selectedDevicename, selectedDevice);
                }}
              >
                Assign Reason
              </Button>
            )}
            {selectedassignmode === 'Supervisor' && (
              <Button
                variant="contained"
                color="secondary"
                className="filter_btn btn_blue"
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenEditDialog4();
                }}
              >
                Assign Supervisor
              </Button>
            )}
          </div>
        </LocalizationProvider>

        {/* Conditional Assign Buttons */}


        {iframeUrl && (selectedassignmode != 'Reason') && (
          <div style={{ position: 'relative' }}>
            <iframe
              key={iframeKey}
              src={iframeUrl}
              height="900"
              title="Operator Dashboard"
              allowFullScreen
              width="100%"
              frameBorder="0"
              style={{ pointerEvents: iframeInteractive ? 'auto' : 'none' }}
            />

            <div //0ee
              style={{
                position: 'absolute',
                top: 2,
                right: 14,
                width: 80,
                height: 40,
                backgroundColor: 'transparent',
                zIndex: 10
              }}
            />
          </div>
        )}
      </div>
      <Dialog
        open={openEditDialog}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            setOpenEditDialog(false);
          }
        }}
        disableEscapeKeyDown={true}
        sx={{
          '& .MuiDialog-paper': {
            width: '700px',
            maxWidth: '700px'
          }
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 24px 0 24px' }}>
          <DialogTitle sx={{ padding: 0 }}>Assign Operator</DialogTitle>
          {/* <VisibilityIcon
    style={{ cursor: 'pointer', color: '#1976d2' }}
    onClick={(e) => {
      e.stopPropagation();
      handleViewClick(selectedDeviceId, selectedDevicename);
    }}
    titleAccess="View Operator"

  /> */}
        </div>

        <DialogContent>
          <br></br>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginLeft: '10px' }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <CustomDateSelect
                name="selectedDate"
                label="Select Date"
                required
                value={selectedDate}
                onChange={(e) => {
                  handleDateChange(e);
                  handleOperatorChange1(e);
                }}
                format="DD-MM-YYYY"
                minDate={isBeforeFirstShift ? dayjs().subtract(1, 'day') : dayjs()} // ✅ Allows yesterday if before first shift
                maxDate={dayjs().add(7, 'day')} // ✅ Allows up to 7 days from today
                slotProps={{
                  textField: {
                    sx: { width: '100%' },
                    error: !!dateErrors.operator,
                    helperText: dateErrors.operator || '',
                  },
                }}
              />
            </LocalizationProvider>
            <CustomDaySelect
              name="shift_no"
              value={selectedShift}
              onChange={(e) => {
                const value = e.target.value;
                handleShiftChange(value);     // First function
                operatorvaluechange(value);       // Second function
              }}
              label="Select Shift"
              required
              options={shiftOptions}

            />
            {/* <CustomDaySelect
              name="operatorselected"
              value={operatorselected}
              onChange={handleFormChange}
              label="Select Operator"
              required={true}
              options={operators}
              error={!operatorselected}
              ref={customDaySelectRef}
            /> */}
            <Autocomplete
              sx={{
                width: '100%',
                '& .MuiOutlinedInput-root': {
                  '&.Mui-focused fieldset': {
                    borderColor: 'orange',
                  },
                  '&.Mui-focused .MuiOutlinedInput-input': {
                    caretColor: 'orange',
                  },
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: 'orange',
                },
              }}
              options={operators}
              getOptionLabel={(option) => option.label}
              value={operators.find(c => c.id === selectedOperatorId) || null}
              onChange={handleOperatorChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Operator"
                  required
                  error={!selectedOperatorId}
                  helperText={!selectedOperatorId ? 'Operator is required' : ''}
                />
              )}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              autoHighlight
              filterSelectedOptions
              componentsProps={{ popper: { style: { minWidth: 'fit-content' } } }}
            />

          </div>
          <br></br>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginLeft: '10px' }}>
            <FormControl fullWidth error={!!timeErrors.startTime}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopTimePicker
                  value={startTime}
                  onChange={(value) => handleTimeChange('start', value, 'operator')}
                  label="Start Time *"
                  views={['hours', 'minutes', 'seconds']}
                  openTo="hours"
                  format="hh:mm:ss A"
                  slotProps={{
                    textField: {
                      error: !!timeErrors.startTime,
                    }
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': { borderColor: timeErrors.startTime ? 'red' : 'black' },
                      '&:hover fieldset': { borderColor: timeErrors.startTime ? 'red' : 'black' },
                      '&.Mui-focused fieldset': { borderColor: timeErrors.startTime ? 'red' : 'orange' },
                    },
                  }}
                />
              </LocalizationProvider>
              <FormHelperText>
                {timeErrors.startTime || " "}
              </FormHelperText>
            </FormControl>

            <FormControl fullWidth error={!!timeErrors.endTime}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopTimePicker
                  value={endTime}
                  onChange={(value) => handleTimeChange('end', value, 'operator')}
                  label="End Time *"
                  views={['hours', 'minutes', 'seconds']}
                  openTo="hours"
                  format="hh:mm:ss A"
                  slotProps={{
                    textField: {
                      error: !!timeErrors.endTime,
                    }
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': { borderColor: timeErrors.endTime ? 'red' : 'black' },
                      '&:hover fieldset': { borderColor: timeErrors.endTime ? 'red' : 'black' },
                      '&.Mui-focused fieldset': { borderColor: timeErrors.endTime ? 'red' : 'orange' },
                    },
                  }}
                />
              </LocalizationProvider>
              <FormHelperText>
                {timeErrors.endTime || " "}
              </FormHelperText>
            </FormControl>
          </div>
        </DialogContent>
        <DialogActions>
          <Button type="submit" variant="contained" className="filter_btn btn_orange" sx={{ backgroundColor: '#ff4444' }} onClick={() => setOpenEditDialog(false)}>Cancel</Button>
          <Button
            type="submit"
            variant="contained"
            className="filter_btn btn_orange"
            sx={{ backgroundColor: '#ff9800' }}
            onClick={handleSaveThreshold}
            disabled={
              savingStates.operator ||
              !selectedOperatorId ||
              !startTime ||
              !endTime ||
              timeErrors.startTime ||
              timeErrors.endTime ||
              dateErrors.operator ||
              !selectedDate?.isValid()
            }
          >
            {savingStates.operator ? 'Saving...' : 'Save'}
          </Button>        </DialogActions>
      </Dialog>


      <Dialog
        open={openEditDialog1}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            setOpenEditDialog(false);
          }
        }}
        disableEscapeKeyDown={true}
        disableBackdropClick={savingComponent}
        sx={{
          '& .MuiDialog-paper': {
            width: dialogWidth,
            maxWidth: dialogWidth
          }
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 24px 0 24px' }}>
          <DialogTitle sx={{ padding: 0 }}>Assign Component</DialogTitle>
        </div>

        <DialogContent>
          <br></br>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginLeft: '10px' }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <CustomDateSelect
                name="selectedDate"
                label="Start Date"
                required
                value={selectedDate}
                onChange={(e) => {
                  handleDateChange(e);
                  handleOperatorChange1(e);
                }}
                format="DD-MM-YYYY"
                minDate={isBeforeFirstShift ? dayjs().subtract(1, 'day') : dayjs()}
                slotProps={{
                  textField: {
                    sx: {
                      width: '100%',
                    },
                    error: selectedDate && !selectedDate.isValid(),
                    helperText: selectedDate && !selectedDate.isValid() ? 'Invalid date format' : '',
                  },
                }}
              />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <CustomDateSelect
                name="endDate"
                label="End Date"
                required
                value={endDate}
                onChange={(e) => {
                  handleEndDate(e);
                }}
                format="DD-MM-YYYY"
                minDate={isBeforeFirstShift ? dayjs().subtract(1, 'day') : dayjs()}
                slotProps={{
                  textField: {
                    sx: { width: '100%' },

                    error:
                      (endDate && !endDate.isValid()),

                    helperText:
                      endDate && !endDate.isValid()
                        ? 'Invalid date format'
                        : '',
                  },
                }}
              />
            </LocalizationProvider>


            <CustomDaySelect
              name="shift_no"
              value={selectedShift}
              onChange={(e) => {
                const value = e.target.value;
                handleShiftChange(value);     // First function
                operatorvaluechange1(value);       // Second function
              }}
              label="Select Shift"
              required
              options={shiftOptions}
            />
            {/* <CustomDaySelect
              name="componentselected"
              value={componentselected}
              onChange={handleFormChange2}
              label="Select Component"
              required={true}
              options={components}
              error={!componentselected}
              ref={customDaySelectRef}
            /> */}
            {cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID && (
              <CustomDaySelect
                name="process"
                sx={{
                  width: '100%',
                }}
                value={selectedProcess}
                onChange={(e) => {
                  const value = e.target.value;
                  setSelectedProcess(value);
                }}
                label="Select Process"
                required
                options={processGroupOptions}
              />
            )}
            <Autocomplete
              sx={{
                width: '100%',
                '& .MuiOutlinedInput-root': {
                  '&.Mui-focused fieldset': { borderColor: 'orange' },
                  '&.Mui-focused .MuiOutlinedInput-input': { caretColor: 'orange' },
                },
                '& .MuiInputLabel-root.Mui-focused': { color: 'orange' },
              }}
              options={filteredComponents}
              getOptionLabel={(option) => option.label}
              value={components.find(c => c.id === selectedComponentId) || null}
              onChange={(event, newValue) => {
                if (newValue) {
                  setselectedcomponent(newValue.value);
                  setSelectedComponentId(newValue.id);
                } else {
                  setselectedcomponent('');
                  setSelectedComponentId('');
                }
              }}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Component"
                  required
                  error={!selectedComponentId}
                  helperText={!selectedComponentId ? 'Component is required' : ''}
                />
              )}
              autoHighlight
              filterSelectedOptions
              componentsProps={{ popper: { style: { width: 'fit-content' } } }}
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginLeft: 10, marginTop: 10, flexWrap: 'wrap' }}>
            <Button
              size="small"
              variant="outlined"
              onClick={handleAutoSuggest}
              disabled={autoSuggestLoading || !selectedDeviceId}
              sx={{
                borderColor: '#10b981',
                color: '#047857',
                textTransform: 'none',
                fontSize: 12,
                fontWeight: 600,
                padding: '4px 14px',
                ':hover': { borderColor: '#059669', backgroundColor: '#ecfdf5' },
              }}
            >
              {autoSuggestLoading ? 'Checking…' : '🎯 Auto-Assign Best Match'}
            </Button>
            {autoSuggestStatus && (
              <span style={{
                fontSize: 12,
                color: autoSuggestStatus.ok ? '#047857' : '#b45309',
                background: autoSuggestStatus.ok ? '#ecfdf5' : '#fef3c7',
                border: `1px solid ${autoSuggestStatus.ok ? '#a7f3d0' : '#fde68a'}`,
                padding: '4px 10px',
                borderRadius: 6,
                flex: 1,
                minWidth: 0,
              }}>
                {autoSuggestStatus.message}
              </span>
            )}
          </div>
          <br></br>
          {selectedShift !== 'ALL' && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                marginLeft: '10px'
              }}
            >
              <FormControl fullWidth error={!!timeErrors.startTime}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopTimePicker
                    label="Start Time *"
                    value={startTime}
                    onChange={handleStartTimeChange1}
                    views={['hours', 'minutes', 'seconds']}
                    openTo="hours"
                    format="hh:mm:ss A"
                    shouldDisableTime={shouldDisableTime}

                    // minTime={
                    //   selectedShiftData && !isOvernight(selectedShiftData)
                    //     ? dayjs().isSame(selectedDate, 'day')
                    //       ? dayjs()
                    //       : dayjs(selectedShiftData.start_time, 'HH:mm:ss')
                    //     : undefined
                    // }
                    // maxTime={
                    //   selectedShiftData && !isOvernight(selectedShiftData)
                    //     ? dayjs(selectedShiftData.end_time, 'HH:mm:ss')
                    //     : undefined
                    // }
                    slotProps={{
                      textField: {
                        error: !!timeErrors.startTime,
                        sx: {
                          '& fieldset': {
                            borderColor: timeErrors.startTime ? 'red' : 'black'
                          },
                          '&:hover fieldset': {
                            borderColor: timeErrors.startTime ? 'red' : 'black'
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: timeErrors.startTime ? 'red' : 'orange'
                          }
                        }
                      }
                    }}
                  />
                </LocalizationProvider>
                <FormHelperText>{timeErrors.startTime || ' '}</FormHelperText>
              </FormControl>

              <FormControl fullWidth error={!!timeErrors.endTime}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopTimePicker
                    label="End Time *"
                    value={endTime}
                    onChange={handleEndTimeChange1}
                    views={['hours', 'minutes', 'seconds']}
                    openTo="hours"
                    format="hh:mm:ss A"
                    shouldDisableTime={shouldDisableTime}

                    // minTime={
                    //   startTime ||
                    //   (selectedShiftData && !isOvernight(selectedShiftData)
                    //     ? dayjs().isSame(selectedDate, 'day')
                    //       ? dayjs()
                    //       : dayjs(selectedShiftData.start_time, 'HH:mm:ss')
                    //     : undefined)
                    // }
                    // maxTime={
                    //   selectedShiftData && !isOvernight(selectedShiftData)
                    //     ? dayjs(selectedShiftData.end_time, 'HH:mm:ss')
                    //     : undefined
                    // }
                    slotProps={{
                      textField: {
                        error: !!timeErrors.endTime,
                        sx: {
                          '& fieldset': {
                            borderColor: timeErrors.endTime ? 'red' : 'black'
                          },
                          '&:hover fieldset': {
                            borderColor: timeErrors.endTime ? 'red' : 'black'
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: timeErrors.endTime ? 'red' : 'orange'
                          }
                        }
                      }
                    }}
                  />
                </LocalizationProvider>
                <FormHelperText>{timeErrors.endTime || ' '}</FormHelperText>
              </FormControl>
            </div>
          )}

        </DialogContent>
        <DialogActions>
          <Button type="submit" variant="contained" className="filter_btn btn_orange" sx={{ backgroundColor: '#ff4444' }} onClick={() => cancelComponentModal()}>Cancel</Button>
          <Button
            type="submit"
            variant="contained"
            className="filter_btn btn_orange"
            sx={{ backgroundColor: '#ff9800' }}
            onClick={handleSaveThreshold1}
            disabled={savingComponent || !selectedComponentId || !startTime || !endTime || timeErrors.startTime || timeErrors.endTime || !selectedDate?.isValid() || !endDate?.isValid()}
          >
            {savingComponent ? 'Saving...' : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openEditDialog2}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            setOpenEditDialog2(false);
          }
        }}
        sx={{
          '& .MuiDialog-paper': {
            width: '70%',
            maxWidth: '70%'
          }
        }}
      >
        <DialogTitle>Assign Reason</DialogTitle>
        <DialogContent>
          <br></br>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginLeft: '10px' }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <CustomDateSelect
                name="selectedDate"
                label="Select Date"
                required
                value={selectedDate}
                onChange={handleDateChange1}
                format="DD-MM-YYYY"
                maxDate={dayjs()} // <-- Disallow future dates
              />
            </LocalizationProvider>
            <CustomDaySelect
              name="shift_no"
              value={selectedShift}
              onChange={(e) => handleShiftChange(e.target.value)}
              label="Select Shift"
              required
              options={shiftOptions}
            />
            <Button
              type="submit"
              variant="contained"
              className="filter_btn btn_orange" sx={{ backgroundColor: '#ff9800' }}
              onClick={() => downtimereason()}
            >
              Submit
            </Button>
          </div>
          {filteredResult.length > 0 ? (
            <div style={{ marginTop: '20px', maxHeight: '300px', overflowY: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ backgroundColor: '#f2f2f2' }}>
                    <th style={{ border: '1px solid #ccc', padding: '8px' }}>Start Time (IST)</th>
                    <th style={{ border: '1px solid #ccc', padding: '8px' }}>End Time (IST)</th>
                    <th style={{ border: '1px solid #ccc', padding: '8px' }}>Duration</th>
                    <th style={{ border: '1px solid #ccc', padding: '8px' }}>Status</th>
                    {(cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID) && (<th style={{ border: '1px solid #ccc', padding: '8px' }}>Group</th>)}

                    <th style={{ border: '1px solid #ccc', padding: '8px' }}>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredResult.map((item, index) => (
                    <tr key={index}>
                      <td style={{ border: '1px solid #ccc', padding: '8px' }}>{formatEpochToIST(item.start)}</td>
                      <td style={{ border: '1px solid #ccc', padding: '8px' }}>{formatEpochToIST(item.end)}</td>
                      <td style={{ border: '1px solid #ccc', padding: '8px' }}>{formatDuration(item.duration)}</td>
                      <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item.status}</td>
                      {(cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID) && (
                        <td>
                          <CustomDaySelect
                            name={`groupselected-${index}`}
                            value={item.groupselected || "all"}
                            onChange={(e) => handleGroupChange(index, e.target.value)}
                            label="Select Group"
                            options={reasonGroupOptions}
                          />
                        </td>)}
                      <td>
                        <CustomDaySelect
                          name={`reasonselected-${index}`}
                          value={item.reasonselected || ''}
                          onChange={(e) => handleReasonChange(index, e.target.value)}
                          label="Select Reason"
                          required={true}
                          options={
                            (() => {
                              const filtered = reasons.filter(r =>
                                !item.groupselected || item.groupselected === "all" || r.group === item.groupselected
                              );
                              if (item.reasonselected === "UNKNOWN" && !filtered.some(r => r.value === "UNKNOWN")) {
                                return [{ value: "UNKNOWN", label: "UNKNOWN", group: item.groupselected }, ...filtered];
                              }
                              return filtered;
                            })()
                          } error={!item.reasonselected}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div style={{ marginTop: '20px', textAlign: 'center', color: '#888' }}>
              <h3>No Data Found</h3>
            </div>
          )}


          {/* <CustomDaySelect
                            name="reasonselected"
                            value={reasonselected}
                            onChange={handleFormChange1}
                            label="Select Reason"
                            required={true}
                            options={reasons}
                            error={!reasonselected}
                            ref={customDaySelectRef}
                        /> */}
        </DialogContent>
        <DialogActions>
          <Button type="submit" variant="contained" className="filter_btn btn_orange" sx={{ backgroundColor: '#ff4444' }} onClick={() => cancelreason()}>Cancel</Button>
          <Button type="submit" variant="contained" className="filter_btn btn_orange" sx={{ backgroundColor: '#ff9800' }} onClick={handleSaveThreshold2}>Save</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={OpenEditDialog4}
        onClose={() => setOpenEditDialog4(false)}

        disableEscapeKeyDown={true}
        sx={{
          '& .MuiDialog-paper': {
            width: '700px',
            maxWidth: '700px'
          }
        }}
      >
        <DialogTitle>Assign Supervisor</DialogTitle>
        <DialogContent>
          <br></br>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginLeft: '10px' }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <CustomDateSelect
                  name="selectedDate"
                  label="Select Date"
                  required
                  value={selectedDate}
                  onChange={(e) => {
                    handleDateChange(e);
                    handleOperatorChange1(e);
                  }}
                  format="DD-MM-YYYY"
                  minDate={isBeforeFirstShift ? dayjs().subtract(1, 'day') : dayjs()}
                  maxDate={dayjs().add(7, 'day')}
                  slotProps={{
                    textField: {
                      sx: { width: '100%' },
                      error: !!dateErrors.supervisor,
                      helperText: dateErrors.supervisor || '',
                    },
                  }}
                />
              </LocalizationProvider>
            </LocalizationProvider>
            <CustomDaySelect
              name="shift_no"
              value={selectedShift}
              onChange={(e) => {
                const value = e.target.value;
                handleShiftChange(value);     // First function
                operatorvaluechange2(value);       // Second function
              }}
              label="Select Shift"
              required
              options={shiftOptions}
            />
            <CustomDaySelect
              name="supervisorselected"
              value={supervisorselected}
              onChange={handleFormChange3}
              label="Select Supervisor"
              required={true}
              options={supervisors}
              error={!supervisorselected}
              ref={selectRef}
            />
          </div>
          <br></br>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginLeft: '10px' }}>
            <FormControl fullWidth error={!!timeErrors.startTime}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopTimePicker
                  value={startTime}
                  onChange={(value) => handleTimeChange('start', value, 'supervisor')}
                  label="Start Time *"
                  views={['hours', 'minutes', 'seconds']}
                  openTo="hours"
                  format="hh:mm:ss A"
                  slotProps={{
                    textField: {
                      error: !!timeErrors.startTime,
                    }
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': { borderColor: timeErrors.startTime ? 'red' : 'black' },
                      '&:hover fieldset': { borderColor: timeErrors.startTime ? 'red' : 'black' },
                      '&.Mui-focused fieldset': { borderColor: timeErrors.startTime ? 'red' : 'orange' },
                    },
                  }}
                />
              </LocalizationProvider>
              <FormHelperText>
                {timeErrors.startTime || " "}
              </FormHelperText>
            </FormControl>

            <FormControl fullWidth error={!!timeErrors.endTime}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopTimePicker
                  value={endTime}
                  onChange={(value) => handleTimeChange('end', value, 'supervisor')}
                  label="End Time *"
                  views={['hours', 'minutes', 'seconds']}
                  openTo="hours"
                  format="hh:mm:ss A"
                  slotProps={{
                    textField: {
                      error: !!timeErrors.endTime,
                    }
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': { borderColor: timeErrors.endTime ? 'red' : 'black' },
                      '&:hover fieldset': { borderColor: timeErrors.endTime ? 'red' : 'black' },
                      '&.Mui-focused fieldset': { borderColor: timeErrors.endTime ? 'red' : 'orange' },
                    },
                  }}
                />
              </LocalizationProvider>
              <FormHelperText>
                {timeErrors.endTime || " "}
              </FormHelperText>
            </FormControl>
          </div>

        </DialogContent>
        <DialogActions>
          <Button type="submit" variant="contained" className="filter_btn btn_orange" sx={{ backgroundColor: '#ff4444' }} onClick={() => setOpenEditDialog4(false)}>Cancel</Button>
          <Button
            type="submit"
            variant="contained"
            className="filter_btn btn_orange"
            sx={{ backgroundColor: '#ff9800' }}
            onClick={handleSaveThreshold3}
            disabled={
              savingStates.supervisor ||
              !supervisorselected ||
              !startTime ||
              !endTime ||
              timeErrors.startTime ||
              timeErrors.endTime ||
              dateErrors.supervisor ||
              !selectedDate?.isValid()
            }
          >
            {savingStates.supervisor ? 'Saving...' : 'Save'}
          </Button>        </DialogActions>
      </Dialog>

      <Dialog
        open={bulkPreviewOpen}
        onClose={() => !bulkApplying && setBulkPreviewOpen(false)}
        maxWidth="lg"
        fullWidth
        sx={{ '& .MuiDialog-paper': { borderRadius: '10px' } }}
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, paddingBottom: '8px' }}>
          <span style={{ fontSize: 22 }}>🎯</span>
          <span style={{ fontSize: 17, fontWeight: 600 }}>Bulk Auto-Assign — Preview</span>
          <span style={{ marginLeft: 'auto', fontSize: 12, color: '#6b7280', fontWeight: 400 }}>
            {bulkPreviewRows.length > 0 && (
              <>Review per-machine recommendations · {bulkSelected.size} of {bulkPreviewRows.filter(r => r.action === 'reassign').length} selected</>
            )}
          </span>
        </DialogTitle>
        <DialogContent dividers sx={{ padding: 0 }}>
          {bulkPreviewLoading ? (
            <div style={{ padding: 40, textAlign: 'center', color: '#6b7280' }}>Loading floor data…</div>
          ) : bulkPreviewRows.length === 0 ? (
            <div style={{ padding: 40, textAlign: 'center', color: '#6b7280' }}>No machines to assess.</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: 'var(--y-bg-soft, #fafafa)', color: '#374151', textAlign: 'left', position: 'sticky', top: 0 }}>
                  <th style={{ padding: '10px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600, width: 50 }}>
                    <input
                      type="checkbox"
                      checked={
                        bulkPreviewRows.filter(r => r.action === 'reassign').length > 0 &&
                        bulkPreviewRows.filter(r => r.action === 'reassign').every(r => bulkSelected.has(r.device_id))
                      }
                      onChange={(e) => {
                        const next = new Set(bulkSelected);
                        const actionable = bulkPreviewRows.filter(r => r.action === 'reassign');
                        if (e.target.checked) actionable.forEach(r => next.add(r.device_id));
                        else actionable.forEach(r => next.delete(r.device_id));
                        setBulkSelected(next);
                      }}
                    />
                  </th>
                  <th style={{ padding: '10px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Machine</th>
                  <th style={{ padding: '10px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Status</th>
                  <th style={{ padding: '10px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Parts</th>
                  <th style={{ padding: '10px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Currently assigned</th>
                  <th style={{ padding: '10px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Suggested</th>
                  <th style={{ padding: '10px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {bulkPreviewRows.map((r) => {
                  const actionColors = {
                    reassign:  { bg: '#ecfdf5', fg: '#047857', label: 'Will reassign' },
                    no_change: { bg: '#f3f4f6', fg: '#6b7280', label: 'Already matches' },
                    no_match:  { bg: '#fef3c7', fg: '#854d0e', label: 'No master match' },
                    skip:      { bg: '#eff6ff', fg: '#1e40af', label: 'Skipped' },
                  };
                  const ac = actionColors[r.action];
                  return (
                    <tr key={r.device_id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                      <td style={{ padding: '10px 14px', textAlign: 'center' }}>
                        {r.action === 'reassign' ? (
                          <input
                            type="checkbox"
                            checked={bulkSelected.has(r.device_id)}
                            onChange={(e) => {
                              const next = new Set(bulkSelected);
                              if (e.target.checked) next.add(r.device_id); else next.delete(r.device_id);
                              setBulkSelected(next);
                            }}
                          />
                        ) : (
                          <span style={{ color: '#d1d5db' }}>—</span>
                        )}
                      </td>
                      <td style={{ padding: '10px 14px', color: '#111827', fontWeight: 500 }}>{r.device_name}</td>
                      <td style={{ padding: '10px 14px', color: '#374151', fontSize: 12 }}>{r.status}</td>
                      <td style={{ padding: '10px 14px', color: '#374151', fontSize: 12 }}>{r.parts}</td>
                      <td style={{ padding: '10px 14px', color: '#374151', fontSize: 12, maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={r.current_component}>
                        {r.current_component}
                      </td>
                      <td style={{ padding: '10px 14px', color: '#065f46', fontSize: 12 }}>
                        {r.suggested ? (
                          <>
                            <b>{r.suggested.component.component_name}</b>
                            <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2 }}>
                              {r.suggested.machining_min}m machining · {r.suggested.variance_pct === 0 ? 'exact' : `${r.suggested.variance_pct}% off`}
                            </div>
                          </>
                        ) : r.skip_reason ? (
                          <span style={{ color: '#6b7280', fontStyle: 'italic' }}>{r.skip_reason}</span>
                        ) : (
                          <span style={{ color: '#9ca3af' }}>—</span>
                        )}
                      </td>
                      <td style={{ padding: '10px 14px' }}>
                        <span style={{
                          background: ac.bg, color: ac.fg, padding: '3px 10px',
                          borderRadius: 999, fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap',
                        }}>{ac.label}</span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: '10px 16px', justifyContent: 'space-between' }}>
          <span style={{ fontSize: 12, color: '#6b7280' }}>
            {bulkPreviewRows.filter(r => r.action === 'reassign').length} actionable ·
            {' '}{bulkPreviewRows.filter(r => r.action === 'no_change').length} already match ·
            {' '}{bulkPreviewRows.filter(r => r.action === 'no_match').length} no master match ·
            {' '}{bulkPreviewRows.filter(r => r.action === 'skip').length} skipped
          </span>
          <div>
            <Button onClick={() => setBulkPreviewOpen(false)} disabled={bulkApplying} sx={{ textTransform: 'none', marginRight: 1 }}>
              Cancel
            </Button>
            <Button
              onClick={handleBulkApply}
              disabled={bulkApplying || bulkSelected.size === 0}
              variant="contained"
              sx={{ textTransform: 'none', backgroundColor: '#10b981', ':hover': { backgroundColor: '#059669' } }}
            >
              {bulkApplying ? 'Applying…' : `Apply Selected (${bulkSelected.size})`}
            </Button>
          </div>
        </DialogActions>
      </Dialog>

      <Dialog
        open={mismatchOpen}
        onClose={() => setMismatchOpen(false)}
        maxWidth="md"
        fullWidth
        sx={{ '& .MuiDialog-paper': { borderRadius: '10px' } }}
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, paddingBottom: '8px' }}>
          <ReportProblemIcon style={{ color: '#dc2626' }} />
          <span style={{ fontSize: 17, fontWeight: 600 }}>Recent Cycle Mismatches</span>
          <span style={{ marginLeft: 'auto', fontSize: 12, color: '#6b7280', fontWeight: 400 }}>
            Last {mismatchEvents.length} events (newest first)
          </span>
        </DialogTitle>
        <DialogContent dividers sx={{ padding: 0 }}>
          {mismatchLoading ? (
            <div style={{ padding: 24, textAlign: 'center', color: '#6b7280' }}>Loading…</div>
          ) : (liveMismatches.length === 0 && mismatchEvents.length === 0 && mismatchSkipped.length === 0) ? (
            <div style={{ padding: 40, textAlign: 'center', color: '#6b7280' }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>✓</div>
              <div style={{ fontSize: 14 }}>All machines are running within tolerance.</div>
              <div style={{ fontSize: 12, marginTop: 6, color: '#9ca3af' }}>
                Mismatches appear here when a machine's actual cycle time differs from
                its assigned component's expected cycle time by more than 20%.
              </div>
            </div>
          ) : (
            <div>
              <div style={{ padding: '12px 16px 6px 16px', background: '#fff7ed', borderBottom: '1px solid #fed7aa' }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#9a3412', display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', background: '#dc2626' }}></span>
                  Live — Detected Right Now
                  <span style={{ marginLeft: 'auto', fontSize: 11, color: '#6b7280', fontWeight: 400 }}>
                    {liveMismatches.length} {liveMismatches.length === 1 ? 'machine' : 'machines'} off-target
                  </span>
                </div>
                <div style={{ fontSize: 11, color: '#9a3412', marginTop: 2 }}>
                  Machines whose machining or handling differs from declared by &gt;20%, this shift only
                  {mismatchShiftStartIst && (
                    <span style={{ color: '#6b7280', marginLeft: 6 }}>
                      · Shift started {mismatchShiftStartIst}
                    </span>
                  )}
                </div>
              </div>
              {liveMismatches.length === 0 ? (
                <div style={{ padding: 16, fontSize: 13, color: '#6b7280', textAlign: 'center' }}>
                  No active mismatches detected.
                </div>
              ) : (() => {
                const toggleSort = (col) => {
                  setMismatchSort((s) => s.col === col
                    ? { col, dir: s.dir === 'desc' ? 'asc' : 'desc' }
                    : { col, dir: 'desc' }
                  );
                };
                const arrow = (col) => mismatchSort.col === col
                  ? (mismatchSort.dir === 'desc' ? ' ▼' : ' ▲')
                  : '';
                const sortVal = (m, col) => {
                  if (col === 'device_name') return (m.device_name || '').toLowerCase();
                  const v = m[col];
                  return v == null ? -1 : v;
                };
                const sortedList = [...liveMismatches].sort((a, b) => {
                  const va = sortVal(a, mismatchSort.col);
                  const vb = sortVal(b, mismatchSort.col);
                  if (va < vb) return mismatchSort.dir === 'desc' ? 1 : -1;
                  if (va > vb) return mismatchSort.dir === 'desc' ? -1 : 1;
                  return 0;
                });
                const headerStyle = {
                  padding: '8px 14px',
                  borderBottom: '1px solid var(--y-border, #e5e7eb)',
                  fontWeight: 600,
                  cursor: 'pointer',
                  userSelect: 'none',
                };
                return (
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                  <thead>
                    <tr style={{ background: 'var(--y-bg-soft, #fafafa)', color: '#374151', textAlign: 'left' }}>
                      <th style={headerStyle} onClick={() => toggleSort('device_name')}>Machine{arrow('device_name')}</th>
                      <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Currently assigned</th>
                      <th style={{ ...headerStyle, textAlign: 'center' }} onClick={() => toggleSort('machining_variance_pct')} title="Machining time identifies the program — operator-independent. Click to sort.">Machining{arrow('machining_variance_pct')}<br/><span style={{ fontSize: 10, color: '#9ca3af', fontWeight: 400 }}>(program signal)</span></th>
                      <th style={{ ...headerStyle, textAlign: 'center' }} onClick={() => toggleSort('handling_variance_pct')} title="Handling time depends on operator speed. Click to sort.">Handling{arrow('handling_variance_pct')}<br/><span style={{ fontSize: 10, color: '#9ca3af', fontWeight: 400 }}>(operator signal)</span></th>
                      <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Suggested fix</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedList.map((m, i) => {
                      const sug = findSuggestedComponent(m.observed_machining_min);
                      const cellStyle = (off) => ({
                        padding: '10px 14px',
                        textAlign: 'center',
                        background: off ? '#fef2f2' : '#ecfdf5',
                      });
                      return (
                        <tr key={`live-${i}`} style={{ borderBottom: '1px solid #f3f4f6' }}>
                          <td style={{ padding: '10px 14px', color: '#111827', fontWeight: 500 }}>
                            <div>{m.device_name}</div>
                            <div style={{ fontSize: 10, color: '#6b7280', marginTop: 2 }}>
                              {m.current_status || ''}{m.parts_produced != null ? ` · ${m.parts_produced}/${m.target_parts ?? '?'} parts` : ''}
                            </div>
                          </td>
                          <td style={{ padding: '10px 14px', color: '#374151' }}>{m.component_name || m.component_code || '-'}</td>
                          <td style={cellStyle(m.machining_off)}>
                            <div style={{ fontSize: 12, color: m.machining_off ? '#b91c1c' : '#065f46', fontWeight: 600 }}>
                              {m.observed_machining_min != null ? `${m.observed_machining_min}m` : 'no data'}
                            </div>
                            <div style={{ fontSize: 10, color: '#6b7280', marginTop: 2 }}>
                              vs declared {m.declared_machining_min}m
                            </div>
                            {m.machining_variance_pct != null && (
                              <div style={{ fontSize: 10, color: m.machining_off ? '#b91c1c' : '#047857', fontWeight: 600, marginTop: 1 }}>
                                {m.machining_off
                                  ? `${m.machining_variance_pct}% ${m.machining_direction === 'slower' ? '▲ slower' : '▼ faster'}`
                                  : `match (${m.machining_variance_pct}%)`}
                              </div>
                            )}
                          </td>
                          <td style={cellStyle(m.handling_off)}>
                            <div style={{ fontSize: 12, color: m.handling_off ? '#b91c1c' : '#065f46', fontWeight: 600 }}>
                              {m.observed_handling_min != null ? `${m.observed_handling_min}m` : 'no data'}
                            </div>
                            <div style={{ fontSize: 10, color: '#6b7280', marginTop: 2 }}>
                              vs declared {m.declared_handling_min}m
                            </div>
                            {m.handling_variance_pct != null && (
                              <div style={{ fontSize: 10, color: m.handling_off ? '#b91c1c' : '#047857', fontWeight: 600, marginTop: 1 }}>
                                {m.handling_off
                                  ? `${m.handling_variance_pct}% ${m.handling_direction === 'slower' ? '▲ slower' : '▼ faster'}`
                                  : `ok (${m.handling_variance_pct}%)`}
                              </div>
                            )}
                          </td>
                          <td style={{ padding: '8px 14px' }}>
                            {!m.machining_off ? (
                              <span style={{ fontSize: 11, color: '#047857', fontStyle: 'italic' }}>
                                Program is correct — handling issue
                              </span>
                            ) : sug ? (
                              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0, flex: 1 }}>
                                  <div title={sug.component.component_name} style={{
                                    fontSize: 12,
                                    color: '#065f46',
                                    fontWeight: 500,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    maxWidth: 180,
                                  }}>
                                    🎯 {sug.component.component_name}
                                  </div>
                                  <div style={{ fontSize: 11, color: '#6b7280' }}>
                                    machining {sug.machining_min}m · {sug.variance_pct === 0 ? 'exact match' : `${sug.variance_pct}% off`}
                                  </div>
                                </div>
                                <Button
                                  size="small"
                                  variant="contained"
                                  onClick={() => assignSuggestedFromPanel(m.device_id, m.device_name, sug.component)}
                                  sx={{
                                    backgroundColor: '#10b981',
                                    color: '#fff',
                                    textTransform: 'none',
                                    fontSize: 11,
                                    padding: '3px 10px',
                                    minWidth: 0,
                                    ':hover': { backgroundColor: '#059669' },
                                  }}
                                >
                                  Assign
                                </Button>
                              </div>
                            ) : (
                              <span style={{ fontSize: 11, color: '#9ca3af', fontStyle: 'italic' }}>
                                No matching machining time in master
                              </span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                );
              })()}

              {mismatchSkipped.length > 0 && (() => {
                const statusPill = (status) => {
                  const colors = {
                    Running:      { bg: '#dcfce7', fg: '#166534' },
                    Idle:         { bg: '#fef3c7', fg: '#854d0e' },
                    Alarm:        { bg: '#fee2e2', fg: '#991b1b' },
                    Setting:      { bg: '#e0e7ff', fg: '#3730a3' },
                    Locked:       { bg: '#f3e8ff', fg: '#6b21a8' },
                    Disconnected: { bg: '#f3f4f6', fg: '#6b7280' },
                  };
                  const c = colors[status] || colors.Disconnected;
                  return (
                    <span style={{
                      background: c.bg, color: c.fg, padding: '2px 8px',
                      borderRadius: 999, fontSize: 11, fontWeight: 600,
                      display: 'inline-block', whiteSpace: 'nowrap',
                    }}>{status}</span>
                  );
                };
                return (
                <>
                  <div style={{ padding: '12px 16px 6px 16px', background: '#eff6ff', borderTop: '1px solid #e5e7eb', borderBottom: '1px solid #bfdbfe' }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: '#1e40af', display: 'flex', alignItems: 'center', gap: 6 }}>
                      ⏸ Not in Production — Skipped
                      <span style={{ marginLeft: 'auto', fontSize: 11, color: '#6b7280', fontWeight: 400 }}>
                        {mismatchSkipped.length} {mismatchSkipped.length === 1 ? 'machine' : 'machines'}
                      </span>
                    </div>
                    <div style={{ fontSize: 11, color: '#1e3a8a', marginTop: 2 }}>
                      Excluded because of alarm, setup, idle reason, or insufficient parts produced this shift
                    </div>
                  </div>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                    <thead>
                      <tr style={{ background: 'var(--y-bg-soft, #fafafa)', color: '#374151', textAlign: 'left' }}>
                        <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Machine</th>
                        <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Status</th>
                        <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Currently assigned</th>
                        <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600, textAlign: 'right' }}>Parts / Target</th>
                        <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Why skipped</th>
                      </tr>
                    </thead>
                    <tbody>
                      {mismatchSkipped.map((s, i) => (
                        <tr key={`skip-${i}`} style={{ borderBottom: '1px solid #f3f4f6' }}>
                          <td style={{ padding: '10px 14px', color: '#111827', fontWeight: 500 }}>{s.device_name}</td>
                          <td style={{ padding: '10px 14px' }}>{statusPill(s.current_status)}</td>
                          <td style={{ padding: '10px 14px', color: '#374151' }}>{s.component_name || '-'}</td>
                          <td style={{ padding: '10px 14px', color: '#374151', textAlign: 'right' }}>
                            <b>{s.parts_produced}</b>
                            <span style={{ color: '#9ca3af' }}> / {s.target_parts ?? '-'}</span>
                          </td>
                          <td style={{ padding: '10px 14px', color: '#1e40af', fontSize: 12 }}>{s.reason}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
                );
              })()}

              <div style={{ padding: '12px 16px 6px 16px', background: 'var(--y-bg-soft, #f9fafb)', borderTop: '1px solid #e5e7eb', borderBottom: '1px solid var(--y-border, #e5e7eb)' }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'flex', alignItems: 'center', gap: 6 }}>
                  📋 Assignment History
                  <span style={{ marginLeft: 'auto', fontSize: 11, color: '#6b7280', fontWeight: 400 }}>
                    {mismatchEvents.length} past {mismatchEvents.length === 1 ? 'event' : 'events'}
                  </span>
                </div>
                <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2 }}>
                  Times a supervisor clicked "Continue Anyway" on the mismatch warning while assigning a component
                </div>
              </div>
              {mismatchEvents.length === 0 ? (
                <div style={{ padding: 16, fontSize: 13, color: '#6b7280', textAlign: 'center' }}>
                  No assignment-time warnings recorded yet.
                </div>
              ) : (
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                  <thead>
                    <tr style={{ background: 'var(--y-bg-soft, #fafafa)', color: '#374151', textAlign: 'left' }}>
                      <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>When (IST)</th>
                      <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Machine</th>
                      <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Component</th>
                      <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600, textAlign: 'right' }}>Expected</th>
                      <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600, textAlign: 'right' }}>Actual</th>
                      <th style={{ padding: '8px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600, textAlign: 'right' }}>Off by</th>
                    </tr>
                  </thead>
                  <tbody>
                    {mismatchEvents.map((ev, i) => (
                      <tr key={`log-${i}`} style={{ borderBottom: '1px solid #f3f4f6' }}>
                        <td style={{ padding: '10px 14px', color: '#374151', whiteSpace: 'nowrap' }}>{ev.ts_ist || '-'}</td>
                        <td style={{ padding: '10px 14px', color: '#111827', fontWeight: 500 }}>{ev.device_name || ev.device_id?.slice(0, 8)}</td>
                        <td style={{ padding: '10px 14px', color: '#374151' }}>{ev.component_name || ev.component_id || '-'}</td>
                        <td style={{ padding: '10px 14px', color: '#374151', textAlign: 'right' }}>{fmtMinSec(ev.expected_sec)}</td>
                        <td style={{ padding: '10px 14px', color: '#374151', textAlign: 'right' }}>{fmtMinSec(ev.actual_median_sec)}</td>
                        <td style={{ padding: '10px 14px', textAlign: 'right' }}>
                          <span style={{
                            background: '#fef2f2',
                            color: '#b91c1c',
                            padding: '2px 8px',
                            borderRadius: 999,
                            fontSize: 12,
                            fontWeight: 600,
                          }}>{ev.variance_pct}%</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: '10px 16px' }}>
          <Button onClick={openMismatchPanel} sx={{ textTransform: 'none' }}>Refresh</Button>
          <Button onClick={() => setMismatchOpen(false)} variant="contained" sx={{ textTransform: 'none', backgroundColor: '#ec6e17', ':hover': { backgroundColor: '#d35a0c' } }}>Close</Button>
        </DialogActions>
      </Dialog>
        </>)}
    </div>
  );
};

export default OperatorDetails;